import { useEffect } from "react";
import "../styles/staking/staking.css";
import Header from "../components/general/Header";
import Footer from "../components/general/Footer";
import { siteSettings } from "../static";

const Staking = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="___gatsby">
      <div style={{ outline: "none" }} tabIndex={-1} id="gatsby-focus-wrapper">
        <div className="DefaultLayout__BackgroundContainer-sc-1h2qfsw-0 cxRxcP">
          {/* header */}
          <Header />

          {/* body */}
          <div className="StakingTemplate__Div-sc-1rbc0ki-0 bEXjHV">
            <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 hXWeeJ">
              <div className="Container-sc-rx245t-0 Header__HeaderContainer-sc-6go0bx-0 dGblwP fHUPfi">
                <div className="Header__Items-sc-6go0bx-9 kqpbur">
                  <div className="Header__LeftAndRightItems-sc-6go0bx-10 Header__LeftItems-sc-6go0bx-11 jplvGd">
                    <img
                      src="data:image/svg+xml;base64,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"
                      alt="btc"
                      className="Header__BtcImg-sc-6go0bx-1 hsCwQc"
                    />
                    <svg
                      width={235}
                      height={256}
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M168.291 97.459 130.14 46.878c-8.717 3.016-18.033 7.267-27.548 12.633l45.987 60.974c7.774-7.677 14.412-15.471 19.712-23.026Z"
                        fill="#C3D3FF"
                      />
                      <path
                        d="m148.577 120.485-45.98-60.971a224.487 224.487 0 0 0-24.789 16.294l48.304 64.044a223.928 223.928 0 0 0 22.465-19.367ZM194.383 70.084l-15.382-20.391c-3.364-4.46-8.759-7.051-15.632-7.917l24.852 32.951 6.162-4.644Z"
                        fill="#C3D3FF"
                      />
                      <path
                        d="m176.746 83.39 11.477-8.662-24.852-32.951c-8.974-1.133-20.465.673-33.232 5.1L168.29 97.46a107.817 107.817 0 0 0 8.456-14.07Z"
                        fill="#C3D3FF"
                      />
                      <path
                        d="m73.77 168.776-38.15-50.583c-7.762 11.064-12.655 21.616-14.032 30.558l24.854 32.953 11.48-8.66a107.874 107.874 0 0 0 15.848-4.268Z"
                        fill="#CBD7FF"
                      />
                      <path
                        d="m24.906 165.96 15.382 20.391 6.166-4.642-24.855-32.953c-1.065 6.842-.056 12.744 3.307 17.204Z"
                        fill="#CFDBFF"
                      />
                      <path
                        d="M77.804 75.805A224.078 224.078 0 0 0 55.33 95.169l45.99 60.975a224.152 224.152 0 0 0 24.787-16.295L77.804 75.805Z"
                        fill="#C3D3FF"
                      />
                      <path
                        d="m101.319 156.144-45.99-60.975c-7.772 7.68-14.41 15.47-19.71 23.023l38.15 50.584c8.73-3.02 18.03-7.263 27.55-12.632Z"
                        fill="#C7D7FF"
                      />
                      <path
                        d="M40.327 186.339c13.338 17.685 58.647 5.993 101.199-26.114s66.234-72.471 52.895-90.155c-13.338-17.685-58.647-5.993-101.199 26.114s-66.234 72.471-52.895 90.155Z"
                        fill="url(#eth_svg__a)"
                      />
                      <path
                        d="M47.239 181.802c11.882 15.753 53.06 4.72 91.975-24.643 38.915-29.363 60.83-65.936 48.948-81.689-11.882-15.752-53.06-4.72-91.975 24.643-38.915 29.363-60.83 65.936-48.948 81.689Z"
                        fill="url(#eth_svg__b)"
                      />
                      <path
                        d="M47.665 177.42c11.091 14.706 50.565 3.627 88.167-24.745 37.602-28.372 59.093-63.293 48.001-77.999-11.091-14.705-50.565-3.626-88.167 24.746-37.602 28.372-59.093 63.293-48.001 77.998Z"
                        fill="url(#eth_svg__c)"
                      />
                      <path
                        style={{ mixBlendMode: "soft-light" }}
                        d="M40.287 186.35c7.959 10.554 27.306 10.644 50.654 2.18l2.285-5.395-3.42-4.529 28.436-98.855a224.001 224.001 0 0 0-25.06 16.448c-42.553 32.102-66.234 72.465-52.895 90.151Z"
                        fill="url(#eth_svg__d)"
                      />
                      <path
                        d="m107.354 116.242 46.482-19.426-26.153 20.623-20.329-1.197ZM103.238 119.489l-2.363 19.089-17.765 14.01 20.128-33.099Z"
                        fill="#828282"
                      />
                      <path
                        d="m127.684 117.439-22.698 17.898 2.369-19.095 20.329 1.197Z"
                        fill="#353535"
                      />
                      <path
                        d="m153.836 96.816-25.554 37.379-.599-16.756 26.153-20.623Z"
                        fill="#303030"
                      />
                      <path
                        d="m127.686 117.439.599 16.756-23.297 1.142 22.698-17.898Z"
                        fill="#131313"
                      />
                      <path
                        d="m124.172 137.447-41.06 15.141 17.765-14.01 23.295-1.131Z"
                        fill="#383837"
                      />
                      <defs>
                        <linearGradient
                          id="eth_svg__a"
                          x1="193.792"
                          y1="70.429"
                          x2="47.255"
                          y2="180.956"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#CBD7FF" />
                          <stop offset={1} stopColor="#CFDBFF" />
                        </linearGradient>
                        <linearGradient
                          id="eth_svg__b"
                          x1="193.602"
                          y1="71.25"
                          x2="71.677"
                          y2="163.214"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#D7E3FF" />
                          <stop offset={1} stopColor="#C3D3FF" />
                        </linearGradient>
                        <linearGradient
                          id="eth_svg__c"
                          x1="182.59"
                          y1="75.499"
                          x2="84.993"
                          y2="149.113"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#C7D7FF" />
                          <stop offset="0.54" stopColor="#CFDBFF" />
                          <stop offset={1} stopColor="#DBE3FF" />
                        </linearGradient>
                        <linearGradient
                          id="eth_svg__d"
                          x1="138.434"
                          y1="248.283"
                          x2="48.795"
                          y2="74.201"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#fff" />
                          <stop offset={1} stopColor="#fff" stopOpacity={0} />
                        </linearGradient>
                      </defs>
                    </svg>
                    <svg
                      width={304}
                      height={283}
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#usdt_svg__a)">
                        <path
                          d="m136.067 61.368-72.604 40.544c2.35 11.875 6.194 24.75 11.45 38.086l87.523-48.874c-8.576-11.48-17.506-21.51-26.369-29.756Z"
                          fill="#00C38D"
                        />
                        <path
                          d="m162.434 91.124-87.523 48.874a293.859 293.859 0 0 0 16.708 35.15l91.929-51.334a293.77 293.77 0 0 0-21.114-32.69Z"
                          fill="#00C38D"
                        />
                        <path
                          d="m105.195 22.536-29.27 16.347c-6.402 3.574-10.742 10.129-13.106 18.91l47.296-26.408-4.92-8.849Z"
                          fill="#00C28D"
                        />
                        <path
                          d="m119.306 47.855-9.184-16.479-47.3 26.414c-3.089 11.463-2.813 26.727.64 44.122l72.604-40.544a141.142 141.142 0 0 0-16.76-13.514Z"
                          fill="#00C28D"
                        />
                        <path
                          d="m211.703 197.053-72.6 40.53c12.979 12.076 25.808 20.328 37.183 23.719l47.3-26.414-9.187-16.475a141.597 141.597 0 0 0-2.696-21.36Z"
                          fill="#00DCA0"
                        />
                        <path
                          d="m199.24 260.082 29.269-16.347-4.921-8.85-47.3 26.414c8.699 2.611 16.55 2.357 22.952-1.217Z"
                          fill="#15DFA9"
                        />
                        <path
                          d="M91.62 175.148a293.998 293.998 0 0 0 21.111 32.693l87.523-48.874a294.446 294.446 0 0 0-16.705-35.153L91.62 175.148Z"
                          fill="#00C38E"
                        />
                        <path
                          d="m200.255 158.967-87.523 48.874c8.579 11.482 17.507 21.507 26.366 29.754l72.607-40.542c-2.359-11.88-6.187-24.749-11.45-38.086Z"
                          fill="#00CE96"
                        />
                        <path
                          d="M228.494 243.689c25.384-14.175 18.357-75.183-15.696-136.266-34.053-61.082-82.237-99.108-107.621-84.932-25.384 14.175-18.357 75.184 15.697 136.266 34.053 61.082 82.236 99.108 107.62 84.932Z"
                          fill="url(#usdt_svg__b)"
                        />
                        <path
                          d="M223.843 233.887c22.612-12.627 15.696-68.147-15.446-124.009-31.143-55.86-74.719-90.91-97.33-78.282-22.612 12.627-15.696 68.148 15.446 124.009 31.143 55.861 74.719 90.91 97.33 78.282Z"
                          fill="url(#usdt_svg__c)"
                        />
                        <path
                          d="M218.224 232.55c21.108-11.787 13.826-65.1-16.266-119.076-30.092-53.977-71.597-88.178-92.705-76.39-21.108 11.787-13.826 65.1 16.266 119.076 30.092 53.977 71.597 88.178 92.705 76.39Z"
                          fill="url(#usdt_svg__d)"
                        />
                        <path
                          style={{ mixBlendMode: "soft-light" }}
                          d="M228.505 243.741c15.157-8.473 18.753-33.598 11.964-65.477l-6.599-3.938-6.504 3.639-123.334-54.688a294.233 294.233 0 0 0 16.858 35.533c34.048 61.079 82.229 99.106 107.615 84.931Z"
                          fill="url(#usdt_svg__e)"
                        />
                        <path
                          d="M160.932 117.001c10.32-7.56 20.212-9.56 23.344-4.247 3.132 5.313-1.579 16.245-10.682 25.877l22.687 38.734-8.649 7.66-22.678-38.729c-10.339 7.578-20.257 9.611-23.382 4.278-3.124-5.333 1.583-16.266 10.706-25.912l-7.067-12.091-11.972 10.6-10.795-18.409 32.59-28.85 10.797 18.426-11.974 10.599 7.075 12.064Zm10.744 18.34c8.053-8.473 12.429-17.598 10.01-21.727-2.419-4.128-10.845-1.915-19.94 4.798l7.905 13.496a35.52 35.52 0 0 1-4.063 4.064 42.325 42.325 0 0 1-4.58 3.58l-7.91-13.503c-8.076 8.499-12.47 17.634-10.047 21.769 2.424 4.135 10.867 1.912 19.974-4.822.59-.433 2.26-1.675 4.485-3.643a48.29 48.29 0 0 0 4.162-4.006"
                          fill="#fff"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="usdt_svg__b"
                          x1="105.547"
                          y1="23.376"
                          x2="222.95"
                          y2="233.611"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#00DAA0" />
                          <stop offset={1} stopColor="#09DDA3" />
                        </linearGradient>
                        <linearGradient
                          id="usdt_svg__c"
                          x1="106.58"
                          y1="23.769"
                          x2="204.266"
                          y2="198.696"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#34E4B4" />
                          <stop offset={1} stopColor="#00C38D" />
                        </linearGradient>
                        <linearGradient
                          id="usdt_svg__d"
                          x1="110.113"
                          y1="38.847"
                          x2="188.309"
                          y2="178.874"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#00CB94" />
                          <stop offset="0.54" stopColor="#09DDA3" />
                          <stop offset={1} stopColor="#46E6BA" />
                        </linearGradient>
                        <linearGradient
                          id="usdt_svg__e"
                          x1="326.673"
                          y1="127.218"
                          x2="84.221"
                          y2="212.339"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#fff" />
                          <stop offset={1} stopColor="#fff" stopOpacity={0} />
                        </linearGradient>
                        <clipPath id="usdt_svg__a">
                          <path
                            fill="#fff"
                            transform="rotate(30 47.27 176.412)"
                            d="M0 0h241.211v187.081H0z"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <div className="Oval-sc-1dczjpv-0 Header__OvalWrapper-sc-6go0bx-2 Header__Oval1-sc-6go0bx-3 bqJIBA iXnKMj gBijGL">
                      3%
                    </div>
                    <div className="Oval-sc-1dczjpv-0 Header__OvalWrapper-sc-6go0bx-2 Header__Oval2-sc-6go0bx-4 bqJIBA iXnKMj eGdCjd">
                      4.7%
                    </div>
                    <div className="Oval-sc-1dczjpv-0 Header__OvalWrapper-sc-6go0bx-2 Header__Oval3-sc-6go0bx-5 bqJIBA iXnKMj eWmhnd">
                      5%
                    </div>
                  </div>
                  <div className="Header__CenterItems-sc-6go0bx-13 eQpIId">
                    <div className="Header__OvalMain-sc-6go0bx-14 hxMreU">
                      Staking Revolution
                    </div>
                    <h1 className="Header__Text2-sc-6go0bx-16 cZCtMQ">
                      <span>Stake</span>
                      <span>Crypto</span>
                      <span>With</span>
                    </h1>
                    <p className="Header__Text1-sc-6go0bx-15 ducFxa">
                      up to <span>5% APY</span>
                    </p>
                    <div className="Header__Buttons-sc-6go0bx-17 jWkIqc">
                      <a
                        href={siteSettings.appLink}
                        className="ButtonLink-sc-125kju0-0 jppsNF"
                      >
                        Get Started
                      </a>
                      <br />
                      <a href={siteSettings.appLink}>
                        <button
                          className="Button-sc-1ptre0p-0 Button2__ButtonWrapper-sc-ni84na-0 dbsBku fdlUSp Header__ButtonWrapper2-sc-6go0bx-18 jYKWpo"
                          type="button"
                        >
                          Learn More
                        </button>
                      </a>
                    </div>
                  </div>
                  <div className="Header__LeftAndRightItems-sc-6go0bx-10 Header__RightItems-sc-6go0bx-12 jplvGd dQaZBK">
                    <svg
                      width={282}
                      height={299}
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="Header__UsdcWrapper-sc-6go0bx-19 cyCOQX"
                    >
                      <path
                        d="m202.962 122.583-34.968-62.672c-10.249 2.032-21.361 5.356-32.87 9.899l42.151 75.545c9.915-7.409 18.568-15.118 25.687-22.772Z"
                        fill="#0374F1"
                      />
                      <path
                        d="m177.275 145.355-42.143-75.54a254.121 254.121 0 0 0-30.342 14.433l44.273 79.352a253.69 253.69 0 0 0 28.212-18.245Z"
                        fill="#0374F1"
                      />
                      <path
                        d="m236.484 95.918-14.099-25.265c-3.083-5.526-8.735-9.27-16.313-11.309l22.779 40.828 7.633-4.254Z"
                        fill="#0073F1"
                      />
                      <path
                        d="m214.632 108.11 14.221-7.936-22.774-40.836c-9.894-2.664-23.068-2.42-38.081.565l34.968 62.672c4.25-4.518 8.15-9.354 11.666-14.465Z"
                        fill="#0073F1"
                      />
                      <path
                        d="m85.843 187.929-34.968-62.672c-10.424 11.207-17.552 22.289-20.482 32.106l22.78 40.829 14.224-7.935a122.17 122.17 0 0 0 18.446-2.328Z"
                        fill="#6EAFF7"
                      />
                      <path
                        d="m31.45 177.185 14.099 25.265 7.639-4.251-22.781-40.829c-2.256 7.511-2.04 14.289 1.043 19.815Z"
                        fill="#7AB6F8"
                      />
                      <path
                        d="M104.782 84.244a253.77 253.77 0 0 0-28.218 18.238l42.152 75.55a253.817 253.817 0 0 0 30.339-14.436l-44.273-79.352Z"
                        fill="#0576F1"
                      />
                      <path
                        d="m118.715 178.032-42.152-75.55c-9.912 7.411-18.57 15.12-25.689 22.775l34.968 62.672c10.264-2.034 21.362-5.356 32.873-9.897Z"
                        fill="#338FF4"
                      />
                      <path
                        d="M45.587 202.444c12.225 21.912 64.879 15.826 117.604-13.593 52.725-29.419 85.556-71.03 73.331-92.942-12.226-21.911-64.879-15.825-117.605 13.594-52.725 29.419-85.556 71.03-73.33 92.941Z"
                        fill="url(#usdc_svg__a)"
                      />
                      <path
                        d="M54.047 198.427c10.89 19.518 58.808 13.53 107.027-13.374 48.218-26.904 78.479-64.537 67.588-84.055-10.89-19.518-58.807-13.53-107.026 13.374-48.218 26.904-78.479 64.537-67.588 84.055Z"
                        fill="url(#usdc_svg__b)"
                      />
                      <path
                        d="M55.204 193.578c10.166 18.22 56.178 11.916 102.769-14.08 46.592-25.997 76.121-61.842 65.954-80.062-10.166-18.22-56.177-11.917-102.769 14.08-46.592 25.996-76.12 61.841-65.954 80.062Z"
                        fill="url(#usdc_svg__c)"
                      />
                      <path
                        style={{ mixBlendMode: "soft-light" }}
                        d="M45.546 202.449c7.294 13.076 28.99 16.181 56.501 10.308l3.401-5.699-3.137-5.612 47.234-106.5a253.785 253.785 0 0 0-30.67 14.566c-52.72 29.405-85.555 71.024-73.33 92.937Z"
                        fill="url(#usdc_svg__d)"
                      />
                      <path
                        d="M172.278 158.058c-23.28 19.146-57.008 29.389-75.522 22.824a.792.792 0 0 1-.709-.32c-.145-.644.474-1.379 1.59-2.031l3.905-2.288c1.393-.818 2.446-1.068 3.43-.914 8.562 2.501 21.015 1.252 34.33-3.803 24.569-9.087 44.557-28.143 44.03-42.138a5.115 5.115 0 0 1 2.132-2.365l3.906-2.288a3.017 3.017 0 0 1 1.22-.534c.897-.391 1.664-.412 1.961-.075a.606.606 0 0 1 .121.507c.869 9.591-6.422 21.932-20.394 33.425Z"
                        fill="#fff"
                      />
                      <path
                        d="M173.334 127.184c.254.768-.261 1.621-1.377 2.272l-6.692 3.923c1.903 3.104-.918 8.057-6.624 12.136l-.279.164c-1.116.652-2.275.78-2.703.299l-1.706-1.932c-.323-.363-.084-1.049.644-1.66 3.651-3.056 4.255-5.245 2.333-7.421-2.137-2.414-5.716-2.15-9.622.138-3.905 2.289-5.494 4.323-3.403 8.598 3.095 5.888 1.993 10.386-7.768 16.11-7.531 4.412-15.522 5.43-20.125 2.626l-6.691 3.927c-1.501.694-2.657.824-3.084.34l-1.603-1.811c-.254-.768.261-1.621 1.374-2.274l6.694-3.918c-2.13-4.803 1.175-9.672 7.724-14.249l.278-.161c1.117-.655 2.272-.782 2.7-.301l1.816 2.053c.321.362.084 1.049-.925 1.828-3.862 2.811-5.972 5.695-3.185 8.838 2.029 2.295 6.594 2.185 11.052-.432 4.459-2.616 5.175-4.68 3.59-8.873-3.095-5.888-1.604-10.429 7.6-15.819 6.963-4.093 14.579-5.066 18.899-2.097l6.412-3.762c1.501-.694 2.66-.822 3.088-.341l1.583 1.799Z"
                        fill="#fff"
                      />
                      <path
                        d="M181.635 111.682c.15.643-.472 1.376-1.59 2.03l-3.902 2.29c-1.395.817-2.446 1.069-3.431.91-8.564-2.498-21.013-1.248-34.329 3.808-24.571 9.084-44.558 28.138-44.031 42.133a4.839 4.839 0 0 1-1.87 2.195l-3.901 2.29a3.074 3.074 0 0 1-1.224.532c-.897.39-1.664.411-1.96.075a.584.584 0 0 1-.122-.507c-.964-9.704 6.433-21.926 20.129-33.256 23.279-19.147 57.007-29.389 75.525-22.823a.783.783 0 0 1 .706.323Z"
                        fill="#fff"
                      />
                      <defs>
                        <linearGradient
                          id="usdc_svg__a"
                          x1="235.774"
                          y1="96.217"
                          x2="54.228"
                          y2="197.513"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#66ABF7" />
                          <stop offset={1} stopColor="#73B2F7" />
                        </linearGradient>
                        <linearGradient
                          id="usdc_svg__b"
                          x1="235.436"
                          y1="97.112"
                          x2="84.382"
                          y2="181.395"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#8CC0F9" />
                          <stop offset={1} stopColor="#0374F1" />
                        </linearGradient>
                        <linearGradient
                          id="usdc_svg__c"
                          x1="222.422"
                          y1="100.166"
                          x2="101.507"
                          y2="167.632"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#2688F3" />
                          <stop offset="0.54" stopColor="#73B2F7" />
                          <stop offset={1} stopColor="#96C6F9" />
                        </linearGradient>
                        <linearGradient
                          id="usdc_svg__d"
                          x1="146.076"
                          y1="287.168"
                          x2="72.519"
                          y2="77.928"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#fff" />
                          <stop offset={1} stopColor="#fff" stopOpacity={0} />
                        </linearGradient>
                      </defs>
                    </svg>
                    <svg
                      width={353}
                      height={373}
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="Header__LinkWrapper-sc-6go0bx-20 QRTGM"
                    >
                      <path
                        d="m99.196 219.59 43.695 78.319c12.807-2.539 26.693-6.693 41.078-12.368l-52.674-94.408c-12.385 9.257-23.203 18.892-32.099 28.457ZM131.297 191.133l52.674 94.408a317.197 317.197 0 0 0 37.913-18.038l-55.325-99.161a317.338 317.338 0 0 0-35.262 22.791Z"
                        fill="#2C5CDA"
                      />
                      <path
                        d="m57.308 252.915 17.618 31.572c3.854 6.902 10.92 11.583 20.388 14.133L66.847 247.6l-9.54 5.315Z"
                        fill="#2A5ADA"
                      />
                      <path
                        d="m84.62 237.677-17.777 9.919 28.467 51.021c12.362 3.327 28.823 3.024 47.584-.708L99.199 219.59a152.746 152.746 0 0 0-14.58 18.087Z"
                        fill="#2A5ADA"
                      />
                      <path
                        d="m245.554 137.938 43.696 78.315c13.026-14.004 21.933-27.852 25.592-40.121l-28.461-51.018-17.771 9.918a152.73 152.73 0 0 0-23.056 2.906Z"
                        fill="#86A1EA"
                      />
                      <path
                        d="M313.518 151.361 295.9 119.789l-9.545 5.312 28.467 51.021c2.813-9.397 2.55-17.859-1.304-24.761Z"
                        fill="#90A9EC"
                      />
                      <path
                        d="M221.879 267.501a317.368 317.368 0 0 0 35.265-22.79l-52.68-94.411a317.15 317.15 0 0 0-37.916 18.037l55.331 99.164Z"
                        fill="#2E5DDB"
                      />
                      <path
                        d="m204.465 150.3 52.684 94.413c12.386-9.26 23.201-18.896 32.1-28.46l-43.696-78.315c-12.811 2.545-26.697 6.69-41.088 12.362Z"
                        fill="#557BE1"
                      />
                      <path
                        d="M295.847 119.791c-15.277-27.38-81.074-19.776-146.96 16.987C83 173.54 41.974 225.538 57.251 252.919c15.278 27.381 81.075 19.776 146.961-16.986 65.886-36.763 106.913-88.761 91.635-116.142Z"
                        fill="url(#link_svg__a)"
                      />
                      <path
                        d="M285.279 124.81c-13.609-24.39-73.487-16.908-133.741 16.713-60.255 33.62-98.07 80.646-84.46 105.036 13.609 24.39 73.487 16.908 133.742-16.712 60.254-33.62 98.068-80.647 84.459-105.037Z"
                        fill="url(#link_svg__b)"
                      />
                      <path
                        d="M283.833 130.875c-12.704-22.768-70.201-14.891-128.422 17.595-58.222 32.485-95.121 77.278-82.418 100.046 12.705 22.769 70.201 14.891 128.423-17.595 58.222-32.485 95.121-77.277 82.417-100.046Z"
                        fill="url(#link_svg__c)"
                      />
                      <path
                        style={{ mixBlendMode: "soft-light" }}
                        d="M295.925 119.802c-9.116-16.34-36.225-20.223-70.608-12.883l-4.25 7.122 3.922 7.015-59.015 133.067a317.157 317.157 0 0 0 38.288-18.194c65.896-36.758 106.926-88.756 91.663-116.127Z"
                        fill="url(#link_svg__d)"
                      />
                      <path
                        d="m129.666 193.72 2.399-7.664 57.294-33.587 9.687.575 26.391 1.417 9.688.575-2.402 7.661-6.529 21.033-2.402 7.661-57.29 33.589-9.688-.575-26.489-1.516-9.688-.575 2.402-7.661 6.627-20.933Zm54.892-25.926-33.112 19.411-6.626 20.93 26.486 1.515 33.114-19.415 6.627-20.925-26.489-1.516Z"
                        fill="#fff"
                      />
                      <defs>
                        <linearGradient
                          id="link_svg__a"
                          x1="58.199"
                          y1="252.553"
                          x2="285.063"
                          y2="125.971"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#7F9CE9" />
                          <stop offset={1} stopColor="#8AA4EB" />
                        </linearGradient>
                        <linearGradient
                          id="link_svg__b"
                          x1="58.629"
                          y1="251.436"
                          x2="247.389"
                          y2="146.115"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#9FB5EE" />
                          <stop offset={1} stopColor="#2C5CDA" />
                        </linearGradient>
                        <linearGradient
                          id="link_svg__c"
                          x1="74.888"
                          y1="247.622"
                          x2="225.989"
                          y2="163.313"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#4A73E0" />
                          <stop offset="0.54" stopColor="#8AA4EB" />
                          <stop offset={1} stopColor="#A8BBF0" />
                        </linearGradient>
                        <linearGradient
                          id="link_svg__d"
                          x1="170.284"
                          y1="13.927"
                          x2="262.201"
                          y2="275.392"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#fff" />
                          <stop offset={1} stopColor="#fff" stopOpacity={0} />
                        </linearGradient>
                      </defs>
                    </svg>
                    <img
                      src="data:image/svg+xml;base64,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"
                      alt="btc"
                      className="Header__BtcWrapper-sc-6go0bx-21 bGrzuQ"
                    />
                    <div className="Oval-sc-1dczjpv-0 Header__OvalWrapper-sc-6go0bx-2 Header__Oval4-sc-6go0bx-6 bqJIBA iXnKMj rJuUX">
                      5%
                    </div>
                    <div className="Oval-sc-1dczjpv-0 Header__OvalWrapper-sc-6go0bx-2 Header__Oval5-sc-6go0bx-7 bqJIBA iXnKMj fGRIik">
                      3%
                    </div>
                    <div className="Oval-sc-1dczjpv-0 Header__OvalWrapper-sc-6go0bx-2 Header__Oval6-sc-6go0bx-8 bqJIBA iXnKMj fpEthP">
                      3%
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 hXWeeJ StakingTemplate__GridBlocksWrapper-sc-1rbc0ki-2 lgFTsP">
              <div className="Container-sc-rx245t-0 dGblwP container">
                <h2 className="Heading-sc-vfylp7-0 jJrhee heading">
                  Up your staking ROI with the highest yield on the market!
                </h2>
                <p className="Subheading-sc-t8ooc1-0 ihSfAf">
                  Earn interest on BTC, ETH, USDT, USDC, and other top
                  cryptocurrencies
                </p>
                <div className="GridBlocks__Grid-sc-ks0dta-0 iFQvzk grid">
                  <div className="GridBlocks__Item-sc-ks0dta-7 fMSHJl item item1 false">
                    <h3 className="GridBlocks__Title-sc-ks0dta-8 iOWUCZ title">
                      USDC Coin <span>(USDC)</span>
                    </h3>
                    <div className="GridBlocks__Image-sc-ks0dta-6 ilIXfh image">
                      <svg
                        width={242}
                        height={262}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 241 261"
                        className="GridBlocks__UsdcWrapper-sc-ks0dta-10 jeIPyh"
                      >
                        <g clipPath="url(#usdc-flat_svg__a)">
                          <path
                            d="M182.822 37.884V244.11c11.916-7.211 22.486-16.437 31.163-27.253V65.076c-8.677-10.755-19.247-19.981-31.163-27.192Z"
                            fill="#6AA4E8"
                          />
                          <path
                            d="M151.66 24.564V257.43a120.784 120.784 0 0 0 31.163-13.32V37.884a117.57 117.57 0 0 0-31.163-13.32Z"
                            fill="#3988E0"
                          />
                          <path
                            d="M120.436 20.47v241.054c10.815 0 21.264-1.405 31.162-4.094V24.564c-9.898-2.689-20.347-4.094-31.162-4.094Z"
                            fill="#096BD8"
                          />
                          <path
                            d="M89.273 24.564V257.43c9.96 2.689 20.409 4.094 31.163 4.094V20.47c-10.754 0-21.264 1.405-31.163 4.094Z"
                            fill="#0062CF"
                          />
                          <path
                            d="M58.049 37.884V244.11a121.7 121.7 0 0 0 31.163 13.32V24.564a117.577 117.577 0 0 0-31.163 13.32Z"
                            fill="#0057B5"
                          />
                          <path
                            d="M26.885 65.076v151.781c8.738 10.755 19.309 19.981 31.163 27.253V37.884c-11.916 7.21-22.425 16.437-31.163 27.192Z"
                            fill="#0054AE"
                          />
                          <path
                            d="M2.627 115.853H.06v32.385h.122c1.588 25.908 11.304 49.677 26.702 68.619V65.076a120.285 120.285 0 0 0-24.258 50.777Z"
                            fill="#0050A8"
                          />
                          <path
                            d="M213.986 65.076v151.781c15.398-18.942 25.114-42.711 26.642-68.68l.244-32.385h-2.627c-3.972-18.881-12.466-36.174-24.259-50.716Z"
                            fill="#97BFEF"
                          />
                          <path
                            d="M120.436 241.054c66.542 0 120.435-53.954 120.435-120.557C240.871 53.955 186.978 0 120.436 0S0 53.955 0 120.558C0 187.1 53.894 241.054 120.436 241.054Z"
                            fill="url(#usdc-flat_svg__b)"
                          />
                          <path
                            d="M120.435 234.333c62.815 0 113.714-50.96 113.714-113.836 0-62.815-50.899-113.776-113.714-113.776S6.721 57.682 6.721 120.558c0 62.815 50.9 113.775 113.714 113.775Z"
                            fill="url(#usdc-flat_svg__c)"
                          />
                          <path
                            d="M120.436 225.84c58.109 0 105.22-47.111 105.22-105.282S178.545 15.276 120.436 15.276c-58.11 0-105.221 47.111-105.221 105.282 0 58.109 47.11 105.282 105.221 105.282Z"
                            fill="url(#usdc-flat_svg__d)"
                          />
                          <g opacity="0.2" fill="#fff">
                            <path d="M194.492 46.256C160.701 12.404 109.619 6.355 69.596 28.108L212.64 171.213c21.753-40.023 15.703-91.106-18.148-124.957ZM194.493 195.532c2.872-2.872 5.56-5.866 8.004-8.982L54.321 38.19c-3.117 2.505-6.11 5.133-8.983 8.005-7.454 7.515-13.565 15.764-18.27 24.624L169.99 213.863c8.799-4.766 17.048-10.876 24.503-18.331Z"></path>
                          </g>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M99.477 182.395c-34.462-12.343-52.182-50.839-39.35-84.874 6.599-18.575 21.202-32.69 39.29-39.35 1.771-.856 2.627-2.2 2.627-4.4V47.6c0-1.772-.856-3.117-2.628-3.544-.427 0-1.344 0-1.772.427-41.978 13.26-64.953 57.927-51.633 99.844 7.944 24.808 26.947 43.811 51.694 51.755 1.772.855 3.544 0 3.972-1.772.428-.428.428-.917.428-1.772v-6.172c0-1.344-1.283-3.055-2.628-3.971Zm46.806-137.912c-1.772-.855-3.544 0-3.972 1.772-.489.428-.489.856-.428 1.772v6.233c0 1.772 1.284 3.483 2.628 4.4 34.462 12.342 52.183 50.838 39.351 84.873-6.661 18.575-21.264 32.69-39.351 39.35-1.772.856-2.628 2.2-2.628 4.4v6.171c0 1.772.856 3.117 2.628 3.544.428 0 1.344 0 1.772-.427 41.978-13.26 64.953-57.927 51.694-99.905-7.944-25.236-27.375-44.24-51.694-52.183Zm-23.036 68.559c18.576 2.2 27.863 7.516 27.863 22.975 0 11.916-8.799 21.203-22.058 23.403v10.632c-.428 2.2-1.772 3.544-3.544 3.544h-6.599c-2.2-.427-3.544-1.772-3.544-3.544V159.42c-14.543-2.2-21.631-10.143-23.403-21.203v-.428c0-1.772 1.344-3.116 3.116-3.116h7.516c1.344 0 2.689.856 3.116 2.628 1.345 6.599 5.316 11.487 16.804 11.487 8.432 0 14.604-4.827 14.604-11.915 0-7.027-4.033-9.716-16.376-11.915-18.515-2.2-27.375-7.944-27.375-22.548 0-11.06 8.372-19.92 21.631-21.691V70.575c.428-2.2 1.772-3.544 3.544-3.544h6.599c2.2.428 3.544 1.772 3.544 3.544v10.632c10.144.917 18.087 8.433 19.859 18.148v.428c0 1.772-1.344 3.116-3.116 3.116h-7.088c-1.345 0-2.689-.855-3.117-2.2-2.26-6.66-6.66-9.287-14.603-9.287-8.86 0-13.26 3.971-13.26 10.143 0 6.171 2.628 9.715 15.887 11.487Z"
                            fill="#fff"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="usdc-flat_svg__b"
                            x1="52.69"
                            y1="11.485"
                            x2="213.134"
                            y2="269.726"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#AECDF2" />
                            <stop offset="0.3" stopColor="#AECDF2" />
                            <stop offset="0.54" stopColor="#B7D5F4" />
                            <stop offset="0.81" stopColor="#0068D6" />
                          </linearGradient>
                          <linearGradient
                            id="usdc-flat_svg__c"
                            x1="35.56"
                            y1="16.143"
                            x2="211.932"
                            y2="233.053"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop offset="0.2" stopColor="#005FC6" />
                            <stop offset="0.49" stopColor="#8ABAED" />
                            <stop offset="0.66" stopColor="#9DC6EF" />
                            <stop offset={1} stopColor="#75AFE9" />
                          </linearGradient>
                          <linearGradient
                            id="usdc-flat_svg__d"
                            x1="197.002"
                            y1="217.714"
                            x2="64.313"
                            y2="49.289"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#096BD8" />
                            <stop offset={1} stopColor="#97BFEF" />
                          </linearGradient>
                          <clipPath id="usdc-flat_svg__a">
                            <path fill="#fff" d="M0 0h241.36v261.524H0z" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="Oval-sc-1dczjpv-0 bqJIBA oval">APY: 5%</div>
                    <a
                      href={siteSettings.appLink}
                      className="ButtonLink-sc-125kju0-0 GridBlocks__ButtonLinkWrapper-sc-ks0dta-9 jppsNF eToDKz button"
                    >
                      <span className="buttonText">Earn USDC Coin</span>
                    </a>
                  </div>
                  <div className="GridBlocks__Item-sc-ks0dta-7 fMSHJl item item2 false">
                    <h3 className="GridBlocks__Title-sc-ks0dta-8 iOWUCZ title">
                      Ethereum <span>(ETH)</span>
                    </h3>
                    <div className="GridBlocks__Image-sc-ks0dta-6 ilIXfh image">
                      <svg
                        width={241}
                        height={261}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 247 267"
                        className="GridBlocks__EthWrapper-sc-ks0dta-11 jDRmyU"
                      >
                        <path
                          d="M186.389 38.61v210.273a123.422 123.422 0 0 0 31.795-27.765V66.376a123.42 123.42 0 0 0-31.795-27.765Z"
                          fill="#F9F7FA"
                        />
                        <path
                          d="M154.586 25.024v237.439a122 122 0 0 0 31.796-13.58V38.617a122.146 122.146 0 0 0-31.796-13.593Z"
                          fill="#F7F5F9"
                        />
                        <path
                          d="M122.791 20.863v245.769c10.995 0 21.654-1.445 31.796-4.161V25.025a122.76 122.76 0 0 0-31.796-4.162Z"
                          fill="#F5F2F7"
                        />
                        <path
                          d="M90.988 25.024v237.44a122.76 122.76 0 0 0 31.796 4.161V20.857a122.755 122.755 0 0 0-31.796 4.161v.006Z"
                          fill="#F3F0F6"
                        />
                        <path
                          d="M59.193 38.61v210.273a121.907 121.907 0 0 0 31.796 13.581V25.024a121.832 121.832 0 0 0-31.796 13.593v-.006ZM27.396 66.376v154.742a123.442 123.442 0 0 0 31.796 27.765V38.61a123.42 123.42 0 0 0-31.796 27.766ZM2.673 118.131H.088v32.992h.13c1.564 26.457 11.494 50.658 27.174 69.995V66.382C15.4 81.177 6.766 98.813 2.673 118.137v-.006Z"
                          fill="#F1EDF4"
                        />
                        <path
                          d="M218.184 66.376v154.742c15.679-19.343 25.609-43.539 27.173-69.996l.224-32.985h-2.672c-4.093-19.318-12.727-36.96-24.725-51.755v-.006Z"
                          fill="#FBFAFC"
                        />
                        <path
                          d="M122.791 245.768c67.815 0 122.791-55.019 122.791-122.884C245.582 55.019 190.606 0 122.791 0S0 55.02 0 122.89c0 67.871 54.976 122.885 122.791 122.885v-.007Z"
                          fill="url(#eth-flat_svg__a)"
                        />
                        <path
                          d="M122.792 238.916c64.034 0 115.945-51.948 115.945-116.032 0-64.083-51.911-116.032-115.945-116.032C58.758 6.852 6.848 58.807 6.848 122.89c0 64.084 51.91 116.032 115.944 116.032v-.006Z"
                          fill="url(#eth-flat_svg__b)"
                        />
                        <path
                          d="M122.841 229.983c59.243 0 107.26-48.061 107.26-107.348 0-59.286-48.023-107.347-107.26-107.347S15.574 63.355 15.574 122.642c0 59.286 48.024 107.347 107.267 107.347v-.006Z"
                          fill="url(#eth-flat_svg__c)"
                        />
                        <g opacity="0.2" fill="#D7D7D7">
                          <path d="M198.304 47.15c-34.48-34.505-86.553-40.678-127.326-18.513l145.828 145.939c22.146-40.803 15.979-92.92-18.502-127.425ZM198.305 199.333a108.367 108.367 0 0 0 8.179-9.164L55.399 38.972a108.404 108.404 0 0 0-9.157 8.185 107.54 107.54 0 0 0-18.658 25.056l145.697 145.802a107.49 107.49 0 0 0 25.03-18.676l-.006-.006Z"></path>
                        </g>
                        <path
                          d="m123.018 42.075-1.082 3.676V152.41l1.082 1.08 49.509-29.265-49.509-82.15Z"
                          fill="#343434"
                        />
                        <path
                          d="m123.02 42.074-49.51 82.15 49.51 29.265V42.074Z"
                          fill="#8C8C8C"
                        />
                        <path
                          d="m123.018 162.863-.61.744v37.994l.61 1.78 49.54-69.768-49.54 29.25Z"
                          fill="#3C3C3B"
                        ></path>
                        <path
                          d="M123.018 203.381v-40.518l-49.51-29.25 49.51 69.768Z"
                          fill="#8C8C8C"
                        />
                        <path
                          d="m123.018 153.49 49.509-29.265-49.509-22.505v51.77Z"
                          fill="#141414"
                        />
                        <path
                          d="m73.508 124.225 49.51 29.265v-51.77l-49.51 22.505Z"
                          fill="#393939"
                        />
                        <defs>
                          <linearGradient
                            id="eth-flat_svg__a"
                            x1="53.718"
                            y1="11.718"
                            x2="217.293"
                            y2="274.991"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FCFBFC" />
                            <stop offset="0.3" stopColor="#FCFBFC" />
                            <stop offset="0.54" stopColor="#FCFBFD" />
                            <stop offset="0.81" stopColor="#F5F2F7" />
                          </linearGradient>
                          <linearGradient
                            id="eth-flat_svg__b"
                            x1="36.257"
                            y1="16.465"
                            x2="216.067"
                            y2="237.601"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop offset="0.2" stopColor="#F1EDF4" />
                            <stop offset="0.49" stopColor="#FAF9FB" />
                            <stop offset="0.66" stopColor="#FBFAFC" />
                            <stop offset={1} stopColor="#FAF8FB" />
                          </linearGradient>
                          <linearGradient
                            id="eth-flat_svg__c"
                            x1="200.897"
                            y1="221.717"
                            x2="65.616"
                            y2="50.005"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#F5F2F7" />
                            <stop offset={1} stopColor="#FBFAFC" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className="Oval-sc-1dczjpv-0 bqJIBA oval">
                      APY: 4.7%
                    </div>
                    <a
                      className="ButtonLink-sc-125kju0-0 GridBlocks__ButtonLinkWrapper-sc-ks0dta-9 jppsNF eToDKz button"
                      href={siteSettings.appLink}
                    >
                      <span className="buttonText">Earn Ethereum</span>
                    </a>
                  </div>
                  <div className="GridBlocks__Item-sc-ks0dta-7 fMSHJl item item3 false">
                    <h3 className="GridBlocks__Title-sc-ks0dta-8 iOWUCZ title">
                      Bitcoin <span>(BTC)</span>
                    </h3>
                    <div className="GridBlocks__Image-sc-ks0dta-6 ilIXfh image">
                      <svg
                        width={242}
                        height={263}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 241 262"
                        className="GridBlocks__BtcWrapper-sc-ks0dta-12 AHdsj"
                      >
                        <path
                          d="M183.184 37.941V244.6a121.31 121.31 0 0 0 31.249-27.288V65.235a121.307 121.307 0 0 0-31.249-27.288v-.006Z"
                          fill="#FDCC90"
                        />
                        <path
                          d="M151.93 24.585v233.358a119.94 119.94 0 0 0 31.249-13.347V37.938A120.051 120.051 0 0 0 151.93 24.58v.006Z"
                          fill="#FCBB6D"
                        />
                        <path
                          d="M120.68 20.497V262.04c10.806 0 21.281-1.42 31.249-4.089V24.587a120.653 120.653 0 0 0-31.249-4.09Z"
                          fill="#FBAA48"
                        />
                        <path
                          d="M89.422 24.587V257.95a120.662 120.662 0 0 0 31.249 4.089V20.497a120.65 120.65 0 0 0-31.25 4.09Z"
                          fill="#FB971E"
                        />
                        <path
                          d="M58.174 37.94v206.658a119.806 119.806 0 0 0 31.249 13.347V24.587a119.738 119.738 0 0 0-31.25 13.36v-.007ZM26.92 65.235v152.082a121.3 121.3 0 0 0 31.249 27.288V37.941a121.297 121.297 0 0 0-31.25 27.288v.006Z"
                          fill="#F88800"
                        />
                        <path
                          d="M2.627 116.094H.086v32.424h.128c1.537 26.002 11.296 49.788 26.707 68.792V65.234C15.135 79.775 6.649 97.108 2.627 116.1v-.006Z"
                          fill="#F78700"
                        />
                        <path
                          d="M214.434 65.233v152.082c15.41-19.01 25.169-42.79 26.706-68.792l.22-32.419h-2.626c-4.023-18.985-12.509-36.324-24.3-50.865v-.006Z"
                          fill="#FDDBB1"
                        />
                        <path
                          d="M120.68 241.543c66.649 0 120.68-54.073 120.68-120.771C241.36 54.074 187.323 0 120.68 0S0 54.074 0 120.772c0 66.698 54.03 120.771 120.68 120.771Z"
                          fill="url(#btc-flat_svg__a)"
                        />
                        <path
                          d="M120.68 234.808c62.933 0 113.951-51.055 113.951-114.037 0-62.982-51.025-114.037-113.951-114.037C57.753 6.734 6.729 57.789 6.729 120.77c0 62.982 51.018 114.037 113.951 114.037Z"
                          fill="url(#btc-flat_svg__b)"
                        />
                        <path
                          d="M120.729 226.306c58.225 0 105.417-47.235 105.417-105.503 0-58.267-47.198-105.496-105.417-105.496-58.218 0-105.422 47.235-105.422 105.503 0 58.267 47.198 105.502 105.422 105.502v-.006Z"
                          fill="url(#btc-flat_svg__c)"
                        />
                        <g opacity="0.2" fill="#fff">
                          <path d="M194.891 46.336C161.003 12.423 109.825 6.356 69.754 28.14L213.075 171.57c21.765-40.103 15.704-91.323-18.184-125.235ZM194.89 195.901a106.625 106.625 0 0 0 8.038-9.006L54.44 38.29a106.52 106.52 0 0 0-9 8.045A105.69 105.69 0 0 0 27.104 70.96l143.192 143.296a105.657 105.657 0 0 0 24.6-18.355h-.006Z"></path>
                        </g>
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M177.26 105.3c2.404-16.077-9.836-24.719-26.573-30.484l5.429-21.778-13.257-3.303-5.285 21.204c-3.485-.869-7.064-1.688-10.622-2.5l5.324-21.344-13.248-3.304-5.433 21.771a437.594 437.594 0 0 1-8.465-1.99l.015-.068-18.281-4.565-3.527 14.16s9.836 2.254 9.629 2.392c5.368 1.34 6.339 4.894 6.178 7.71l-6.185 24.811c.37.094.849.23 1.378.442l-.379-.094-.006-.002a84.685 84.685 0 0 0-1.016-.25l-8.67 34.755c-.656 1.631-2.321 4.079-6.074 3.149.133.193-9.636-2.404-9.636-2.404l-6.581 15.175 17.251 4.3c1.89.474 3.756.961 5.604 1.442l.004.001c1.29.337 2.571.671 3.844.996l-5.486 22.028 13.242 3.303 5.432-21.794c3.618.982 7.128 1.888 10.565 2.742l-5.414 21.691 13.257 3.303 5.486-21.986c22.605 4.278 39.603 2.553 46.758-17.894 5.765-16.462-.287-25.957-12.18-32.149 8.662-1.998 15.187-7.695 16.926-19.464l-.004-.003v.001Zm-30.29 42.472c-3.759 15.103-27.4 8.859-38.217 6.002-.973-.257-1.842-.486-2.583-.67l7.279-29.183c.904.225 2.009.473 3.26.754 11.189 2.511 34.112 7.655 30.262 23.097h-.001Zm-28.016-36.641c9.018 2.407 28.691 7.657 32.117-6.07h.001c3.499-14.04-15.62-18.272-24.957-20.34a113.962 113.962 0 0 1-2.734-.626l-6.6 26.467c.623.155 1.354.351 2.173.569Z"
                          fill="#fff"
                        />
                        <g style={{ mixBlendMode: "multiply" }} opacity="0.5">
                          <path
                            d="M183.184 37.941V244.6a121.31 121.31 0 0 0 31.249-27.288V65.235a121.307 121.307 0 0 0-31.249-27.288v-.006Z"
                            fill="#FDCC90"
                          />
                          <path
                            d="M151.93 24.585v233.358a119.94 119.94 0 0 0 31.249-13.347V37.938A120.051 120.051 0 0 0 151.93 24.58v.006Z"
                            fill="#FCBB6D"
                          />
                          <path
                            d="M120.68 20.497V262.04c10.806 0 21.281-1.42 31.249-4.089V24.587a120.653 120.653 0 0 0-31.249-4.09Z"
                            fill="#FBAA48"
                          />
                          <path
                            d="M89.422 24.587V257.95a120.662 120.662 0 0 0 31.249 4.089V20.497a120.65 120.65 0 0 0-31.25 4.09Z"
                            fill="#FB971E"
                          />
                          <path
                            d="M58.174 37.94v206.658a119.806 119.806 0 0 0 31.249 13.347V24.587a119.738 119.738 0 0 0-31.25 13.36v-.007ZM26.92 65.235v152.082a121.3 121.3 0 0 0 31.249 27.288V37.941a121.297 121.297 0 0 0-31.25 27.288v.006Z"
                            fill="#F88800"
                          />
                          <path
                            d="M2.627 116.094H.086v32.424h.128c1.537 26.002 11.296 49.788 26.707 68.792V65.234C15.135 79.775 6.649 97.108 2.627 116.1v-.006Z"
                            fill="#F78700"
                          />
                          <path
                            d="M214.434 65.233v152.082c15.41-19.01 25.169-42.79 26.706-68.792l.22-32.419h-2.626c-4.023-18.985-12.509-36.324-24.3-50.865v-.006Z"
                            fill="#FDDBB1"
                          />
                          <path
                            d="M120.68 241.543c66.649 0 120.68-54.073 120.68-120.771C241.36 54.074 187.323 0 120.68 0S0 54.074 0 120.772c0 66.698 54.03 120.771 120.68 120.771Z"
                            fill="url(#btc-flat_svg__d)"
                          />
                          <path
                            d="M120.68 234.808c62.933 0 113.951-51.055 113.951-114.037 0-62.982-51.025-114.037-113.951-114.037C57.753 6.734 6.729 57.789 6.729 120.77c0 62.982 51.018 114.037 113.951 114.037Z"
                            fill="url(#btc-flat_svg__e)"
                          />
                          <path
                            d="M120.729 226.306c58.225 0 105.417-47.235 105.417-105.503 0-58.267-47.198-105.496-105.417-105.496-58.218 0-105.422 47.235-105.422 105.503 0 58.267 47.198 105.502 105.422 105.502v-.006Z"
                            fill="url(#btc-flat_svg__f)"
                          />
                          <g opacity="0.2" fill="#fff">
                            <path d="M194.891 46.336C161.003 12.423 109.825 6.356 69.754 28.14L213.075 171.57c21.765-40.103 15.704-91.323-18.184-125.235ZM194.89 195.901a106.625 106.625 0 0 0 8.038-9.006L54.44 38.29a106.52 106.52 0 0 0-9 8.045A105.69 105.69 0 0 0 27.104 70.96l143.192 143.296a105.657 105.657 0 0 0 24.6-18.355h-.006Z"></path>
                          </g>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M177.26 105.3c2.404-16.077-9.836-24.719-26.573-30.484l5.429-21.778-13.257-3.303-5.285 21.204c-3.485-.869-7.064-1.688-10.622-2.5l5.324-21.344-13.248-3.304-5.433 21.771a437.594 437.594 0 0 1-8.465-1.99l.015-.068-18.281-4.565-3.527 14.16s9.836 2.254 9.629 2.392c5.368 1.34 6.339 4.894 6.178 7.71l-6.185 24.811c.37.094.849.23 1.378.442l-.379-.094-.006-.002a84.685 84.685 0 0 0-1.016-.25l-8.67 34.755c-.656 1.631-2.321 4.079-6.074 3.149.133.193-9.636-2.404-9.636-2.404l-6.581 15.175 17.251 4.3c1.89.474 3.756.961 5.604 1.442l.004.001c1.29.337 2.571.671 3.844.996l-5.486 22.028 13.242 3.303 5.432-21.794c3.618.982 7.128 1.888 10.565 2.742l-5.414 21.691 13.257 3.303 5.486-21.986c22.605 4.278 39.603 2.553 46.758-17.894 5.765-16.462-.287-25.957-12.18-32.149 8.662-1.998 15.187-7.695 16.926-19.464l-.004-.003v.001Zm-30.29 42.472c-3.759 15.103-27.4 8.859-38.217 6.002-.973-.257-1.842-.486-2.583-.67l7.279-29.183c.904.225 2.009.473 3.26.754 11.189 2.511 34.112 7.655 30.262 23.097h-.001Zm-28.016-36.641c9.018 2.407 28.691 7.657 32.117-6.07h.001c3.499-14.04-15.62-18.272-24.957-20.34a113.962 113.962 0 0 1-2.734-.626l-6.6 26.467c.623.155 1.354.351 2.173.569Z"
                            fill="#fff"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="btc-flat_svg__a"
                            x1="52.794"
                            y1="11.51"
                            x2="213.552"
                            y2="270.258"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FEE3C2" />
                            <stop offset="0.3" stopColor="#FEE3C2" />
                            <stop offset="0.54" stopColor="#FEE6CA" />
                            <stop offset="0.81" stopColor="#FBA63F" />
                          </linearGradient>
                          <linearGradient
                            id="btc-flat_svg__b"
                            x1="35.627"
                            y1="16.175"
                            x2="212.351"
                            y2="233.516"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop offset="0.2" stopColor="#FA8900" />
                            <stop offset="0.49" stopColor="#FDD7AA" />
                            <stop offset="0.66" stopColor="#FEDDB6" />
                            <stop offset={1} stopColor="#FDD099" />
                          </linearGradient>
                          <linearGradient
                            id="btc-flat_svg__c"
                            x1="197.438"
                            y1="218.181"
                            x2="64.488"
                            y2="49.428"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FBAA48" />
                            <stop offset={1} stopColor="#FDDBB1" />
                          </linearGradient>
                          <linearGradient
                            id="btc-flat_svg__d"
                            x1="52.794"
                            y1="11.51"
                            x2="213.552"
                            y2="270.258"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FEE3C2" />
                            <stop offset="0.3" stopColor="#FEE3C2" />
                            <stop offset="0.54" stopColor="#FEE6CA" />
                            <stop offset="0.81" stopColor="#FBA63F" />
                          </linearGradient>
                          <linearGradient
                            id="btc-flat_svg__e"
                            x1="35.627"
                            y1="16.175"
                            x2="212.351"
                            y2="233.516"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop offset="0.2" stopColor="#FA8900" />
                            <stop offset="0.49" stopColor="#FDD7AA" />
                            <stop offset="0.66" stopColor="#FEDDB6" />
                            <stop offset={1} stopColor="#FDD099" />
                          </linearGradient>
                          <linearGradient
                            id="btc-flat_svg__f"
                            x1="197.438"
                            y1="218.181"
                            x2="64.488"
                            y2="49.428"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FBAA48" />
                            <stop offset={1} stopColor="#FDDBB1" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div className="Oval-sc-1dczjpv-0 bqJIBA oval">APY: 3%</div>
                    <a
                      className="ButtonLink-sc-125kju0-0 GridBlocks__ButtonLinkWrapper-sc-ks0dta-9 jppsNF eToDKz button"
                      href={siteSettings.appLink}
                    >
                      <span className="buttonText">Earn Bitcoin</span>
                    </a>
                  </div>
                  <div className="GridBlocks__Item-sc-ks0dta-7 fMSHJl item item4 false">
                    <h3 className="GridBlocks__Title-sc-ks0dta-8 iOWUCZ title">
                      Tether <span>(USDT)</span>
                    </h3>
                    <div className="GridBlocks__Image-sc-ks0dta-6 ilIXfh image">
                      <svg
                        width={242}
                        height={263}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 241 262"
                        className="GridBlocks__UsdtWrapper-sc-ks0dta-13 hNWsHp"
                      >
                        <g clipPath="url(#usdt-flat_svg__a)">
                          <path
                            d="M183.014 37.924v206.44c11.927-7.218 22.509-16.454 31.195-27.281V65.143c-8.686-10.765-19.268-20.001-31.195-27.22Z"
                            fill="#51DDB9"
                          />
                          <path
                            d="M151.818 24.59v233.108a120.92 120.92 0 0 0 31.196-13.334V37.924a117.698 117.698 0 0 0-31.196-13.335Z"
                            fill="#16D29E"
                          />
                          <path
                            d="M120.561 20.491v241.306c10.826 0 21.286-1.407 31.195-4.099V24.589c-9.909-2.691-20.369-4.098-31.195-4.098Z"
                            fill="#00C791"
                          />
                          <path
                            d="M89.365 24.59v233.108c9.97 2.692 20.43 4.099 31.196 4.099V20.491c-10.766 0-21.287 1.407-31.196 4.098Z"
                            fill="#00BA86"
                          />
                          <path
                            d="M58.11 37.924v206.44a121.825 121.825 0 0 0 31.195 13.334V24.589a117.694 117.694 0 0 0-31.196 13.335Z"
                            fill="#00956B"
                          />
                          <path
                            d="M26.914 65.143v151.94c8.747 10.766 19.329 20.002 31.195 27.281V37.924c-11.927 7.218-22.448 16.454-31.195 27.22Z"
                            fill="#008B64"
                          />
                          <path
                            d="M2.63 115.973H.06v32.419h.123c1.59 25.935 11.316 49.729 26.73 68.691V65.143a120.41 120.41 0 0 0-24.283 50.83Z"
                            fill="#00825E"
                          />
                          <path
                            d="M214.209 65.143v151.94c15.414-18.962 25.14-42.756 26.669-68.752l.245-32.419h-2.631c-3.975-18.9-12.478-36.21-24.283-50.769Z"
                            fill="#87E7CB"
                          />
                          <path
                            d="M120.561 241.306c66.611 0 120.561-54.011 120.561-120.684C241.122 54.011 187.172 0 120.561 0S0 54.01 0 120.683c0 66.612 53.95 120.623 120.561 120.623Z"
                            fill="url(#usdt-flat_svg__b)"
                          />
                          <path
                            d="M120.561 234.577c62.88 0 113.833-51.013 113.833-113.955 0-62.88-50.953-113.894-113.833-113.894-62.88 0-113.832 51.014-113.832 113.955 0 62.881 50.952 113.894 113.832 113.894Z"
                            fill="url(#usdt-flat_svg__c)"
                          />
                          <path
                            d="M120.561 226.075c58.17 0 105.33-47.16 105.33-105.392 0-58.231-47.16-105.391-105.33-105.391s-105.33 47.16-105.33 105.391c0 58.171 47.16 105.392 105.33 105.392Z"
                            fill="url(#usdt-flat_svg__d)"
                          />
                          <g opacity="0.2" fill="#fff">
                            <path d="M194.696 46.304C160.871 12.417 109.735 6.36 69.67 28.137l143.193 143.254c21.776-40.064 15.72-91.2-18.167-125.087ZM194.696 195.736c2.875-2.875 5.567-5.872 8.013-8.992L54.379 38.23c-3.12 2.508-6.117 5.138-8.992 8.013-7.463 7.523-13.58 15.78-18.29 24.65l143.071 143.193c8.808-4.771 17.066-10.888 24.528-18.35Z"></path>
                          </g>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M134.445 127.289c-.795.062-4.771.306-13.762.306-7.096 0-12.173-.244-13.946-.306-27.526-1.223-48.017-5.994-48.017-11.744 0-5.749 20.552-10.521 48.017-11.744v18.717c1.773.123 6.973.429 14.068.429 8.563 0 12.845-.367 13.579-.429v-18.717c27.464 1.223 47.955 5.995 47.955 11.744.062 5.689-20.429 10.521-47.894 11.744Zm0-25.445v-16.76h38.291V59.577H68.506v25.568h38.292v16.76c-31.135 1.407-54.562 7.585-54.562 14.986 0 7.401 23.428 13.579 54.562 14.986v53.705h27.709v-53.705c31.073-1.407 54.439-7.585 54.439-14.986-.062-7.462-23.428-13.579-54.501-15.047Z"
                            fill="#fff"
                          />
                        </g>
                        <g
                          style={{ mixBlendMode: "multiply" }}
                          opacity="0.5"
                          clipPath="url(#usdt-flat_svg__e)"
                        >
                          <path
                            d="M183.014 37.924v206.44c11.927-7.218 22.509-16.454 31.195-27.281V65.143c-8.686-10.765-19.268-20.001-31.195-27.22Z"
                            fill="#51DDB9"
                          />
                          <path
                            d="M151.818 24.59v233.108a120.92 120.92 0 0 0 31.196-13.334V37.924a117.698 117.698 0 0 0-31.196-13.335Z"
                            fill="#16D29E"
                          />
                          <path
                            d="M120.561 20.491v241.306c10.826 0 21.286-1.407 31.195-4.099V24.589c-9.909-2.691-20.369-4.098-31.195-4.098Z"
                            fill="#00C791"
                          />
                          <path
                            d="M89.365 24.59v233.108c9.97 2.692 20.43 4.099 31.196 4.099V20.491c-10.766 0-21.287 1.407-31.196 4.098Z"
                            fill="#00BA86"
                          />
                          <path
                            d="M58.11 37.924v206.44a121.825 121.825 0 0 0 31.195 13.334V24.589a117.694 117.694 0 0 0-31.196 13.335Z"
                            fill="#00956B"
                          />
                          <path
                            d="M26.914 65.143v151.94c8.747 10.766 19.329 20.002 31.195 27.281V37.924c-11.927 7.218-22.448 16.454-31.195 27.22Z"
                            fill="#008B64"
                          />
                          <path
                            d="M2.63 115.973H.06v32.419h.123c1.59 25.935 11.316 49.729 26.73 68.691V65.143a120.41 120.41 0 0 0-24.283 50.83Z"
                            fill="#00825E"
                          />
                          <path
                            d="M214.209 65.143v151.94c15.414-18.962 25.14-42.756 26.669-68.752l.245-32.419h-2.631c-3.975-18.9-12.478-36.21-24.283-50.769Z"
                            fill="#87E7CB"
                          />
                          <path
                            d="M120.561 241.306c66.611 0 120.561-54.011 120.561-120.684C241.122 54.011 187.172 0 120.561 0S0 54.01 0 120.683c0 66.612 53.95 120.623 120.561 120.623Z"
                            fill="url(#usdt-flat_svg__f)"
                          />
                          <path
                            d="M120.561 234.577c62.88 0 113.833-51.013 113.833-113.955 0-62.88-50.953-113.894-113.833-113.894-62.88 0-113.832 51.014-113.832 113.955 0 62.881 50.952 113.894 113.832 113.894Z"
                            fill="url(#usdt-flat_svg__g)"
                          />
                          <path
                            d="M120.561 226.075c58.17 0 105.33-47.16 105.33-105.392 0-58.231-47.16-105.391-105.33-105.391s-105.33 47.16-105.33 105.391c0 58.171 47.16 105.392 105.33 105.392Z"
                            fill="url(#usdt-flat_svg__h)"
                          />
                          <g opacity="0.2" fill="#fff">
                            <path d="M194.696 46.304C160.871 12.417 109.735 6.36 69.67 28.137l143.193 143.254c21.776-40.064 15.72-91.2-18.167-125.087ZM194.696 195.736c2.875-2.875 5.567-5.872 8.013-8.992L54.379 38.23c-3.12 2.508-6.117 5.138-8.992 8.013-7.463 7.523-13.58 15.78-18.29 24.65l143.071 143.193c8.808-4.771 17.066-10.888 24.528-18.35Z"></path>
                          </g>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M134.445 127.289c-.795.062-4.771.306-13.762.306-7.096 0-12.173-.244-13.946-.306-27.526-1.223-48.017-5.994-48.017-11.744 0-5.749 20.552-10.521 48.017-11.744v18.717c1.773.123 6.973.429 14.068.429 8.563 0 12.845-.367 13.579-.429v-18.717c27.464 1.223 47.955 5.995 47.955 11.744.062 5.689-20.429 10.521-47.894 11.744Zm0-25.445v-16.76h38.291V59.577H68.506v25.568h38.292v16.76c-31.135 1.407-54.562 7.585-54.562 14.986 0 7.401 23.428 13.579 54.562 14.986v53.705h27.709v-53.705c31.073-1.407 54.439-7.585 54.439-14.986-.062-7.462-23.428-13.579-54.501-15.047Z"
                            fill="#fff"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="usdt-flat_svg__b"
                            x1="52.745"
                            y1="11.497"
                            x2="213.356"
                            y2="270.006"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#A0ECD8" />
                            <stop offset="0.3" stopColor="#A0ECD8" />
                            <stop offset="0.54" stopColor="#ABEFDB" />
                            <stop offset="0.81" stopColor="#00C48D" />
                          </linearGradient>
                          <linearGradient
                            id="usdt-flat_svg__c"
                            x1="35.598"
                            y1="16.16"
                            x2="212.153"
                            y2="233.295"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop offset="0.2" stopColor="#00AD7D" />
                            <stop offset="0.49" stopColor="#75E5C5" />
                            <stop offset="0.66" stopColor="#89E9CD" />
                            <stop offset={1} stopColor="#5CE0BC" />
                          </linearGradient>
                          <linearGradient
                            id="usdt-flat_svg__d"
                            x1="197.207"
                            y1="217.94"
                            x2="64.38"
                            y2="49.34"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#00C791" />
                            <stop offset={1} stopColor="#87E7CB" />
                          </linearGradient>
                          <linearGradient
                            id="usdt-flat_svg__f"
                            x1="52.745"
                            y1="11.497"
                            x2="213.356"
                            y2="270.006"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#A0ECD8" />
                            <stop offset="0.3" stopColor="#A0ECD8" />
                            <stop offset="0.54" stopColor="#ABEFDB" />
                            <stop offset="0.81" stopColor="#00C48D" />
                          </linearGradient>
                          <linearGradient
                            id="usdt-flat_svg__g"
                            x1="35.598"
                            y1="16.16"
                            x2="212.153"
                            y2="233.295"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop offset="0.2" stopColor="#00AD7D" />
                            <stop offset="0.49" stopColor="#75E5C5" />
                            <stop offset="0.66" stopColor="#89E9CD" />
                            <stop offset={1} stopColor="#5CE0BC" />
                          </linearGradient>
                          <linearGradient
                            id="usdt-flat_svg__h"
                            x1="197.207"
                            y1="217.94"
                            x2="64.38"
                            y2="49.34"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#00C791" />
                            <stop offset={1} stopColor="#87E7CB" />
                          </linearGradient>
                          <clipPath id="usdt-flat_svg__a">
                            <path fill="#fff" d="M0 0h241.36v262.017H0z" />
                          </clipPath>
                          <clipPath id="usdt-flat_svg__e">
                            <path fill="#fff" d="M0 0h241.36v262.017H0z" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="Oval-sc-1dczjpv-0 bqJIBA oval">APY: 5%</div>
                    <a
                      className="ButtonLink-sc-125kju0-0 GridBlocks__ButtonLinkWrapper-sc-ks0dta-9 jppsNF eToDKz button"
                      href={siteSettings.appLink}
                    >
                      <span className="buttonText">Earn Tether</span>
                    </a>
                  </div>
                  <div className="GridBlocks__Item-sc-ks0dta-7 fMSHJl item item5 lastItem">
                    <h3 className="GridBlocks__Title-sc-ks0dta-8 iOWUCZ title">
                      Chainlink <span>(Link)</span>
                    </h3>
                    <div className="GridBlocks__Image-sc-ks0dta-6 ilIXfh image">
                      <svg
                        width={241}
                        height={261}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 241 262"
                        className="GridBlocks__LinkWrapper-sc-ks0dta-14 kmOkpM"
                      >
                        <g clipPath="url(#link-flat_svg__a)">
                          <path
                            d="M182.822 37.884V244.11c11.916-7.211 22.486-16.437 31.163-27.253V65.076c-8.677-10.755-19.247-19.981-31.163-27.192Z"
                            fill="#6AA4E8"
                          />
                          <path
                            d="M151.66 24.564V257.43a120.784 120.784 0 0 0 31.163-13.32V37.884a117.57 117.57 0 0 0-31.163-13.32Z"
                            fill="#3988E0"
                          />
                          <path
                            d="M120.436 20.47v241.054c10.815 0 21.264-1.405 31.162-4.094V24.564c-9.898-2.689-20.347-4.094-31.162-4.094Z"
                            fill="#096BD8"
                          />
                          <path
                            d="M89.273 24.564V257.43c9.96 2.689 20.409 4.094 31.163 4.094V20.47c-10.754 0-21.264 1.405-31.163 4.094Z"
                            fill="#0062CF"
                          />
                          <path
                            d="M58.049 37.884V244.11a121.7 121.7 0 0 0 31.163 13.32V24.564a117.577 117.577 0 0 0-31.163 13.32Z"
                            fill="#0057B5"
                          />
                          <path
                            d="M26.885 65.076v151.781c8.738 10.755 19.309 19.981 31.163 27.253V37.884c-11.916 7.21-22.425 16.437-31.163 27.192Z"
                            fill="#0054AE"
                          />
                          <path
                            d="M2.627 115.853H.06v32.385h.122c1.588 25.908 11.304 49.677 26.702 68.619V65.076a120.285 120.285 0 0 0-24.258 50.777Z"
                            fill="#0050A8"
                          />
                          <path
                            d="M213.986 65.076v151.781c15.398-18.942 25.114-42.711 26.642-68.68l.244-32.385h-2.627c-3.972-18.881-12.466-36.174-24.259-50.716Z"
                            fill="#97BFEF"
                          />
                          <path
                            d="M120.436 241.054c66.542 0 120.435-53.954 120.435-120.557C240.871 53.955 186.978 0 120.436 0S0 53.955 0 120.558C0 187.1 53.894 241.054 120.436 241.054Z"
                            fill="url(#link-flat_svg__b)"
                          />
                          <path
                            d="M120.435 234.333c62.815 0 113.714-50.961 113.714-113.836 0-62.815-50.899-113.776-113.714-113.776S6.721 57.682 6.721 120.558c0 62.814 50.9 113.775 113.714 113.775Z"
                            fill="url(#link-flat_svg__c)"
                          />
                          <path
                            d="M120.436 225.84c58.109 0 105.22-47.111 105.22-105.282S178.545 15.276 120.436 15.276c-58.11 0-105.221 47.111-105.221 105.282 0 58.109 47.11 105.282 105.221 105.282Z"
                            fill="url(#link-flat_svg__d)"
                          />
                          <g opacity="0.2" fill="#fff">
                            <path d="M194.492 46.256C160.701 12.404 109.619 6.355 69.596 28.108L212.64 171.213c21.753-40.023 15.703-91.106-18.148-124.957ZM194.493 195.532c2.872-2.872 5.56-5.866 8.004-8.982L54.321 38.19c-3.117 2.505-6.11 5.133-8.983 8.005-7.454 7.515-13.565 15.764-18.27 24.624L169.99 213.863c8.799-4.766 17.048-10.876 24.503-18.331Z"></path>
                          </g>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="m107.489 56.7 13.19-7.584 13.189 7.584 35.942 20.774L183 85.058v71.884l-13.19 7.584-35.612 20.774-13.19 7.584-13.189-7.584-36.272-20.774-13.19-7.584V85.058l13.19-7.584L107.49 56.7Zm-22.753 43.527v41.547l35.942 20.774 35.942-20.774v-41.547l-35.942-20.774-35.942 20.774Z"
                            fill="#fff"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="link-flat_svg__b"
                            x1="52.69"
                            y1="11.485"
                            x2="213.134"
                            y2="269.726"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#AECDF2" />
                            <stop offset="0.3" stopColor="#AECDF2" />
                            <stop offset="0.54" stopColor="#B7D5F4" />
                            <stop offset="0.81" stopColor="#0068D6" />
                          </linearGradient>
                          <linearGradient
                            id="link-flat_svg__c"
                            x1="35.56"
                            y1="16.143"
                            x2="211.932"
                            y2="233.053"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop offset="0.2" stopColor="#005FC6" />
                            <stop offset="0.49" stopColor="#8ABAED" />
                            <stop offset="0.66" stopColor="#9DC6EF" />
                            <stop offset={1} stopColor="#75AFE9" />
                          </linearGradient>
                          <linearGradient
                            id="link-flat_svg__d"
                            x1="197.002"
                            y1="217.714"
                            x2="64.313"
                            y2="49.289"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#096BD8" />
                            <stop offset={1} stopColor="#97BFEF" />
                          </linearGradient>
                          <clipPath id="link-flat_svg__a">
                            <path fill="#fff" d="M0 0h241.36v261.524H0z" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="Oval-sc-1dczjpv-0 bqJIBA oval">APY: 3%</div>
                    <a
                      className="ButtonLink-sc-125kju0-0 GridBlocks__ButtonLinkWrapper-sc-ks0dta-9 jppsNF eToDKz button"
                      href={siteSettings.appLink}
                    >
                      <span className="buttonText">Earn Chainlink</span>
                    </a>
                  </div>
                </div>
              </div>
            </section>
            <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 Slideshow__WrapperWrapper-sc-nh29sz-1 hXWeeJ kXpRcg">
              <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 hXWeeJ StakingTemplate__SlideshowWrapper-sc-1rbc0ki-1 lkXmkm">
                <div className="Container-sc-rx245t-0 dGblwP">
                  <h2 className="Heading-sc-vfylp7-0 jJrhee">
                    Trade + Stake = Trade Staked Crypto
                  </h2>
                  <p className="Subheading-sc-t8ooc1-0 Slideshow__SubheadingWrapper-sc-nh29sz-0 ihSfAf idtgRL">
                    Trade while staking and get up to a 5% yield return at the
                    same time
                  </p>
                  <div className="first-chart__animation-wrapper">
                    <div className="Slideshow__ChartWrapper-sc-nh29sz-2 cFVAok">
                      <div className="Slideshow__Chart-sc-nh29sz-3 gbxnBr">
                        <div className="Slideshow__BoxText-sc-nh29sz-4 kVOvFk">
                          <div className="Slideshow__Box1-sc-nh29sz-7 MdwGg">
                            <p className="Slideshow__TextWithCircle-sc-nh29sz-13 dYMeEh">
                              Competitors Staking Profit
                            </p>
                          </div>
                        </div>
                        <div className="Slideshow__CircleText-sc-nh29sz-6 jYcfjL">
                          or
                        </div>
                        <div className="Slideshow__BoxText-sc-nh29sz-4 kVOvFk">
                          <div className="Slideshow__Box1-sc-nh29sz-7 Slideshow__Box2-sc-nh29sz-8 MdwGg cTULgQ">
                            <p className="Slideshow__TextWithCircle-sc-nh29sz-13 dYMeEh">
                              Competitors Trading Profit
                            </p>
                          </div>
                        </div>
                        <div className="Slideshow__BoxText-sc-nh29sz-4 Slideshow__BoxesText-sc-nh29sz-5 kVOvFk hwxlKY">
                          <div className="Slideshow__Box1-sc-nh29sz-7 Slideshow__Box3-sc-nh29sz-9 MdwGg gThYNk">
                            <p className="Slideshow__SideText1-sc-nh29sz-11 dzTJkW">
                              Your Staking Profit on {siteSettings.siteName}
                            </p>
                          </div>
                          <div className="Slideshow__Box1-sc-nh29sz-7 Slideshow__Box2-sc-nh29sz-8 Slideshow__Box4-sc-nh29sz-10 MdwGg cTULgQ lglaia">
                            <p className="Slideshow__TextWithCircle-sc-nh29sz-13 Slideshow__TextWithoutCircle-sc-nh29sz-14 dYMeEh fmxdMX">
                              Your Combined Profit on {siteSettings.siteName}
                            </p>
                            <p className="Slideshow__SideText1-sc-nh29sz-11 Slideshow__SideText2-sc-nh29sz-12 dzTJkW gzgQFT">
                              Your Trading Profit on {siteSettings.siteName}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="second-chart__animation-wrapper">
                    <div className="SecondChart__ChartWrapper-sc-19cex7-0 efIVDg">
                      <div className="SecondChart__Chart-sc-19cex7-1 kzjkdx">
                        <div className="SecondChart__ChartSvgWrapper-sc-19cex7-2 bXjwZr">
                          <div
                            data-gatsby-image-wrapper=""
                            style={{ left: "unset", top: 2, right: "-80px" }}
                            className="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                          >
                            <div style={{ maxWidth: 2280, display: "block" }}>
                              <img
                                alt=""
                                role="presentation"
                                aria-hidden="true"
                                src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='1072'%20width='2280'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                style={{
                                  maxWidth: "100%",
                                  display: "block",
                                  position: "static",
                                }}
                              />
                            </div>
                            <div
                              aria-hidden="true"
                              data-placeholder-image=""
                              style={{
                                opacity: 1,
                                transition: "opacity 500ms linear",
                                backgroundColor: "#080808",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                              }}
                            ></div>
                            <img
                              data-gatsby-image-ssr=""
                              data-main-image=""
                              style={{ opacity: 0 }}
                              sizes="(min-width: 2280px) 2280px, 100vw"
                              decoding="async"
                              loading="lazy"
                              data-src="/static/b3a064423a21c7675076c5b0b99f215c/d4a30/chart-block-desk2.png"
                              data-srcset="/static/b3a064423a21c7675076c5b0b99f215c/c0654/chart-block-desk2.png 570w,/static/b3a064423a21c7675076c5b0b99f215c/d47bf/chart-block-desk2.png 1140w,/static/b3a064423a21c7675076c5b0b99f215c/d4a30/chart-block-desk2.png 2280w"
                              alt="chart"
                            />
                            <noscript>
                              &lt;img data-gatsby-image-ssr=""
                              data-main-image="" style="opacity:0"
                              sizes="(min-width: 2280px) 2280px, 100vw"
                              decoding="async" loading="lazy"
                              src="static/b3a064423a21c7675076c5b0b99f215c/d4a30/chart-block-desk2.png"
                              srcSet="/static/b3a064423a21c7675076c5b0b99f215c/c0654/chart-block-desk2.png
                              570w,/static/b3a064423a21c7675076c5b0b99f215c/d47bf/chart-block-desk2.png
                              1140w,/static/b3a064423a21c7675076c5b0b99f215c/d4a30/chart-block-desk2.png
                              2280w" alt="chart" /&gt;
                            </noscript>
                          </div>
                          <div className="SecondChart__TextContainerDesktop-sc-19cex7-16 eIWlUQ">
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__Text1-sc-19cex7-4 dFsRQz bbZgkn">
                              Competitors Staking Profit
                            </p>
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__Text2-sc-19cex7-5 dFsRQz cEohbr">
                              Competitors Trading Profit
                            </p>
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__Text3-sc-19cex7-6 dFsRQz hLCLRs">
                              Your Combined Profit on {siteSettings.siteName}
                            </p>
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__Text4-sc-19cex7-7 dFsRQz chSVGU">
                              Your Staking Profit on {siteSettings.siteName}
                            </p>
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__Text5-sc-19cex7-8 dFsRQz gyEbME">
                              Your Trading Profit on {siteSettings.siteName}
                            </p>
                          </div>
                        </div>
                        <div className="SecondChart__ChartSvgMobileWrapper-sc-19cex7-14 fyQISQ">
                          <div
                            data-gatsby-image-wrapper=""
                            className="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                          >
                            <div style={{ maxWidth: 300, display: "block" }}>
                              <img
                                alt=""
                                role="presentation"
                                aria-hidden="true"
                                src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='467.99999999999994'%20width='300'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                style={{
                                  maxWidth: "100%",
                                  display: "block",
                                  position: "static",
                                }}
                              />
                            </div>
                            <div
                              aria-hidden="true"
                              data-placeholder-image=""
                              style={{
                                opacity: 1,
                                transition: "opacity 500ms linear",
                                backgroundColor: "#080808",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                              }}
                            ></div>
                            <img
                              data-gatsby-image-ssr=""
                              data-main-image=""
                              style={{ opacity: 0 }}
                              sizes="(min-width: 300px) 300px, 100vw"
                              decoding="async"
                              loading="lazy"
                              data-src="/static/5c6b8e84c2a1603a86ce7aefaf2ad1f9/f54f9/chart-block-mob2.png"
                              data-srcset="/static/5c6b8e84c2a1603a86ce7aefaf2ad1f9/0f007/chart-block-mob2.png 75w,/static/5c6b8e84c2a1603a86ce7aefaf2ad1f9/52f19/chart-block-mob2.png 150w,/static/5c6b8e84c2a1603a86ce7aefaf2ad1f9/f54f9/chart-block-mob2.png 300w"
                              alt="chart"
                            />
                            <noscript>
                              &lt;img data-gatsby-image-ssr=""
                              data-main-image="" style="opacity:0"
                              sizes="(min-width: 300px) 300px, 100vw"
                              decoding="async" loading="lazy"
                              src="static/5c6b8e84c2a1603a86ce7aefaf2ad1f9/f54f9/chart-block-mob2.png"
                              srcSet="/static/5c6b8e84c2a1603a86ce7aefaf2ad1f9/0f007/chart-block-mob2.png
                              75w,/static/5c6b8e84c2a1603a86ce7aefaf2ad1f9/52f19/chart-block-mob2.png
                              150w,/static/5c6b8e84c2a1603a86ce7aefaf2ad1f9/f54f9/chart-block-mob2.png
                              300w" alt="chart" /&gt;
                            </noscript>
                          </div>
                          <div className="SecondChart__TextContainer-sc-19cex7-15 cgvaNH">
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__TextMobile-sc-19cex7-9 SecondChart__TextMobile1-sc-19cex7-10 dFsRQz elxbQT jIYyYW">
                              Competitors Staking Profit
                            </p>
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__TextMobile-sc-19cex7-9 SecondChart__TextMobile2-sc-19cex7-11 dFsRQz elxbQT iKZNIi">
                              Your Combined Profit on {siteSettings.siteName}
                            </p>
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__TextMobile-sc-19cex7-9 SecondChart__TextMobile3-sc-19cex7-12 dFsRQz elxbQT kTCHGC">
                              Your Staking Profit on {siteSettings.siteName}
                            </p>
                            <p className="SecondChart__Text-sc-19cex7-3 SecondChart__TextMobile-sc-19cex7-9 SecondChart__TextMobile4-sc-19cex7-13 dFsRQz elxbQT loUSIb">
                              Your Trading Profit on {siteSettings.siteName}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="third-chart__animation-wrapper">
                    <div className="ThirdChart__ChartWrapper-sc-1czaf2f-0 UjjHV">
                      <div className="ThirdChart__Chart-sc-1czaf2f-1 daOCEI">
                        <div className="ThirdChart__ChartSvgWrapper-sc-1czaf2f-2 krJRNi">
                          <div
                            data-gatsby-image-wrapper=""
                            style={{ left: "unset", top: 2, right: "-80px" }}
                            className="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                          >
                            <div style={{ maxWidth: 2280, display: "block" }}>
                              <img
                                alt=""
                                role="presentation"
                                aria-hidden="true"
                                src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='900'%20width='2280'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                style={{
                                  maxWidth: "100%",
                                  display: "block",
                                  position: "static",
                                }}
                              />
                            </div>
                            <div
                              aria-hidden="true"
                              data-placeholder-image=""
                              style={{
                                opacity: 1,
                                transition: "opacity 500ms linear",
                                backgroundColor: "#080808",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                              }}
                            ></div>
                            <img
                              data-gatsby-image-ssr=""
                              data-main-image=""
                              style={{ opacity: 0 }}
                              sizes="(min-width: 2280px) 2280px, 100vw"
                              decoding="async"
                              loading="lazy"
                              data-src="/static/43155fa4c527daf087ed2432b9b7f5b0/5b905/chart-block-desk3.png"
                              data-srcset="/static/43155fa4c527daf087ed2432b9b7f5b0/4f801/chart-block-desk3.png 570w,/static/43155fa4c527daf087ed2432b9b7f5b0/0c8e2/chart-block-desk3.png 1140w,/static/43155fa4c527daf087ed2432b9b7f5b0/5b905/chart-block-desk3.png 2280w"
                              alt="chart"
                            />
                            <noscript>
                              &lt;img data-gatsby-image-ssr=""
                              data-main-image="" style="opacity:0"
                              sizes="(min-width: 2280px) 2280px, 100vw"
                              decoding="async" loading="lazy"
                              src="static/43155fa4c527daf087ed2432b9b7f5b0/5b905/chart-block-desk3.png"
                              srcSet="/static/43155fa4c527daf087ed2432b9b7f5b0/4f801/chart-block-desk3.png
                              570w,/static/43155fa4c527daf087ed2432b9b7f5b0/0c8e2/chart-block-desk3.png
                              1140w,/static/43155fa4c527daf087ed2432b9b7f5b0/5b905/chart-block-desk3.png
                              2280w" alt="chart" /&gt;
                            </noscript>
                          </div>
                          <div className="ThirdChart__TextContainerDesktop-sc-1czaf2f-3 etPhHM">
                            <p className="ThirdChart__Text-sc-1czaf2f-6 ThirdChart__Text1-sc-1czaf2f-7 fAFOMf jUGNni">
                              Competitors Staking Profit
                            </p>
                            <p className="ThirdChart__Text-sc-1czaf2f-6 ThirdChart__Text2-sc-1czaf2f-8 fAFOMf ovAbG">
                              Competitors Trading Profit
                            </p>
                            <p className="ThirdChart__Text-sc-1czaf2f-6 ThirdChart__Text3-sc-1czaf2f-9 fAFOMf ijcHNU">
                              Your Staking Profit on {siteSettings.siteName}
                            </p>
                            <p className="ThirdChart__Text-sc-1czaf2f-6 ThirdChart__Text4-sc-1czaf2f-10 fAFOMf iKABGi">
                              Your Trading Profit on {siteSettings.siteName}
                            </p>
                          </div>
                        </div>
                        <div className="ThirdChart__ChartSvgMobileWrapper-sc-1czaf2f-5 dxMout">
                          <div
                            data-gatsby-image-wrapper=""
                            className="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                          >
                            <div style={{ maxWidth: 303, display: "block" }}>
                              <img
                                alt=""
                                role="presentation"
                                aria-hidden="true"
                                src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='436'%20width='303'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                style={{
                                  maxWidth: "100%",
                                  display: "block",
                                  position: "static",
                                }}
                              />
                            </div>
                            <div
                              aria-hidden="true"
                              data-placeholder-image=""
                              style={{
                                opacity: 1,
                                transition: "opacity 500ms linear",
                                backgroundColor: "#080808",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                              }}
                            ></div>
                            <img
                              data-gatsby-image-ssr=""
                              data-main-image=""
                              style={{ opacity: 0 }}
                              sizes="(min-width: 303px) 303px, 100vw"
                              decoding="async"
                              loading="lazy"
                              data-src="/static/77139bb1921a93a8d05bda3d73492878/34616/chart-block-mob3.png"
                              data-srcset="/static/77139bb1921a93a8d05bda3d73492878/dcbda/chart-block-mob3.png 76w,/static/77139bb1921a93a8d05bda3d73492878/318e8/chart-block-mob3.png 152w,/static/77139bb1921a93a8d05bda3d73492878/34616/chart-block-mob3.png 303w"
                              alt="chart"
                            />
                            <noscript>
                              &lt;img data-gatsby-image-ssr=""
                              data-main-image="" style="opacity:0"
                              sizes="(min-width: 303px) 303px, 100vw"
                              decoding="async" loading="lazy"
                              src="static/77139bb1921a93a8d05bda3d73492878/34616/chart-block-mob3.png"
                              srcSet="/static/77139bb1921a93a8d05bda3d73492878/dcbda/chart-block-mob3.png
                              76w,/static/77139bb1921a93a8d05bda3d73492878/318e8/chart-block-mob3.png
                              152w,/static/77139bb1921a93a8d05bda3d73492878/34616/chart-block-mob3.png
                              303w" alt="chart" /&gt;
                            </noscript>
                          </div>
                          <div className="ThirdChart__TextContainer-sc-1czaf2f-4 fyzEoA">
                            <p className="ThirdChart__Text-sc-1czaf2f-6 ThirdChart__TextMobile-sc-1czaf2f-11 ThirdChart__TextMobile1-sc-1czaf2f-12 fAFOMf jKRFJj bfSxjW">
                              Competitors Trading Profit
                            </p>
                            <p className="ThirdChart__Text-sc-1czaf2f-6 ThirdChart__TextMobile-sc-1czaf2f-11 ThirdChart__TextMobile2-sc-1czaf2f-13 fAFOMf jKRFJj YmQWj">
                              Your Combined Profit on {siteSettings.siteName}
                            </p>
                            <p className="ThirdChart__Text-sc-1czaf2f-6 ThirdChart__TextMobile-sc-1czaf2f-11 ThirdChart__TextMobile3-sc-1czaf2f-14 fAFOMf jKRFJj eskgcS">
                              Your Staking Profit on {siteSettings.siteName}
                            </p>
                            <p className="ThirdChart__Text-sc-1czaf2f-6 ThirdChart__TextMobile-sc-1czaf2f-11 ThirdChart__TextMobile4-sc-1czaf2f-15 fAFOMf jKRFJj bTbROX">
                              Your Trading Profit on {siteSettings.siteName}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </section>
            <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 hXWeeJ">
              <div className="Container-sc-rx245t-0 ItemText__ContainerWrapper-sc-11es8wh-0 dGblwP feARPU">
                <div className="ItemText__HeadingSubheading-sc-11es8wh-1 bvUiXS">
                  <h2 className="Heading-sc-vfylp7-0 ItemText__HeadingWrapper-sc-11es8wh-2 jJrhee gKLAxI">
                    How does {siteSettings.siteName} help you earn more?
                  </h2>
                  <p className="Subheading-sc-t8ooc1-0 ItemText__SubheadingWrapper-sc-11es8wh-3 ihSfAf EWTUJ">
                    The unimaginable is now a reality. {siteSettings.siteName}{" "}
                    now lets traders use their staked assets to trade crypto
                    with up to 100x leverage. Boost your staking by trading with{" "}
                    {siteSettings.siteName}
                  </p>
                </div>
                <div className="ItemText__Desktop-sc-11es8wh-4 etpYSM">
                  <div className="ItemText__FlexAnimatedBlock-sc-11es8wh-7 bcWMfk">
                    <div className="ItemText__Item1-sc-11es8wh-8 hxLKQh">
                      <p className="ItemText__Text-sc-11es8wh-9 epiYSY">
                        {siteSettings.siteName}{" "}
                        <span className="color1">Staking</span>
                      </p>
                      <div className="ItemText__Arrow1-sc-11es8wh-11 fvOeKe" />
                      <div className="ItemText__Arrow1-sc-11es8wh-11 ItemText__Arrow3-sc-11es8wh-13 fvOeKe dcctcg" />
                    </div>
                    <div className="ItemText__Item1-sc-11es8wh-8 ItemText__Item2-sc-11es8wh-15 hxLKQh gCOWZg">
                      <p className="ItemText__Text-sc-11es8wh-9 ItemText__TextWrapper-sc-11es8wh-10 epiYSY iXHNd">
                        Your Staking income
                      </p>
                    </div>
                  </div>
                  <div className="ItemText__FlexAnimatedBlock-sc-11es8wh-7 bcWMfk">
                    <div className="ItemText__Item1-sc-11es8wh-8 ItemText__Item2-sc-11es8wh-15 hxLKQh gCOWZg">
                      <p className="ItemText__Text-sc-11es8wh-9 ItemText__TextWrapper-sc-11es8wh-10 epiYSY iXHNd">
                        Your Trading income
                      </p>
                    </div>
                    <div className="ItemText__Item1-sc-11es8wh-8 ItemText__Item3-sc-11es8wh-16 hxLKQh khjHSF">
                      <p className="ItemText__Text-sc-11es8wh-9 epiYSY">
                        {siteSettings.siteName}{" "}
                        <span className="color2">Trading</span>
                      </p>
                      <div className="ItemText__Arrow1-sc-11es8wh-11 ItemText__Arrow2-sc-11es8wh-12 fvOeKe kwKPsM" />
                      <div className="ItemText__Arrow1-sc-11es8wh-11 ItemText__Arrow3-sc-11es8wh-13 ItemText__Arrow4-sc-11es8wh-14 fvOeKe dcctcg gZYkZt"></div>
                    </div>
                  </div>
                </div>
                <div className="ItemText__Mobile-sc-11es8wh-5 kMNUHI">
                  <svg
                    width={300}
                    height={231}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ItemText__TempItemTextWrapper-sc-11es8wh-6 jNAeGg"
                  >
                    <g filter="url(#temp-item-text_svg__a)">
                      <mask id="temp-item-text_svg__b" fill="#fff">
                        <path d="M0 13a8 8 0 0 1 8-8h130a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V13Z" />
                      </mask>
                      <path
                        d="M0 13a8 8 0 0 1 8-8h130a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V13Z"
                        fill="#3071EE"
                        fillOpacity="0.1"
                      />
                      <path
                        d="M0 5h146H0Zm146 72c0 5.523-4.477 10-10 10H10C4.477 87 0 82.523 0 77c0 3.314 3.582 6 8 6h130c4.418 0 8-2.686 8-6ZM0 85V5v80ZM146 5v80V5Z"
                        fill="#51DDB9"
                        mask="url(#temp-item-text_svg__b)"
                      />
                    </g>
                    <path
                      d="M54.86 25.8h2.273V37H54.94v-7.264l-3.152 5.2h-.256l-3.152-5.184V37h-2.208V25.8h2.272l3.216 5.296 3.2-5.296Zm10.344 4.144V29h2.064v8h-2.064v-.944c-.619.779-1.488 1.168-2.608 1.168-1.067 0-1.984-.405-2.752-1.216-.758-.821-1.136-1.824-1.136-3.008 0-1.173.378-2.17 1.136-2.992.768-.821 1.685-1.232 2.752-1.232 1.12 0 1.989.39 2.608 1.168Zm-3.808 4.688c.416.416.944.624 1.584.624.64 0 1.168-.208 1.584-.624.426-.427.64-.97.64-1.632 0-.661-.214-1.2-.64-1.616-.416-.427-.944-.64-1.584-.64-.64 0-1.168.213-1.584.64-.416.416-.624.955-.624 1.616 0 .661.208 1.205.624 1.632ZM71.203 29v1.376c.182-.501.491-.88.928-1.136.438-.267.939-.4 1.504-.4v2.304c-.629-.085-1.194.043-1.696.384-.49.33-.736.88-.736 1.648V37H69.14v-8h2.064Zm9.47.992V29h2.017v7.616c0 1.227-.411 2.17-1.232 2.832-.811.65-1.792.976-2.944.976-1.814 0-3.078-.65-3.792-1.952l1.76-1.008c.394.747 1.093 1.12 2.096 1.12.65 0 1.162-.17 1.536-.512.373-.341.56-.827.56-1.456v-.864c-.608.81-1.462 1.216-2.56 1.216-1.131 0-2.08-.395-2.848-1.184-.758-.81-1.136-1.781-1.136-2.912 0-1.13.384-2.096 1.152-2.896.768-.8 1.712-1.2 2.832-1.2 1.098 0 1.952.405 2.56 1.216Zm-.64 4.464c.427-.416.64-.944.64-1.584 0-.64-.213-1.157-.64-1.552-.415-.416-.949-.624-1.6-.624-.64 0-1.178.208-1.615.624-.416.395-.624.912-.624 1.552s.208 1.168.624 1.584c.426.405.965.608 1.616.608.65 0 1.184-.203 1.6-.608Zm12.304-.608h-6.032c.267 1.003 1.019 1.504 2.256 1.504.79 0 1.387-.267 1.792-.8l1.664.96c-.79 1.141-1.952 1.712-3.488 1.712-1.322 0-2.384-.4-3.184-1.2-.8-.8-1.2-1.808-1.2-3.024 0-1.195.395-2.197 1.184-3.008.779-.81 1.792-1.216 3.04-1.216 1.184 0 2.15.405 2.896 1.216.768.81 1.152 1.813 1.152 3.008 0 .224-.026.507-.08.848Zm-6.064-1.6h4.08c-.117-.523-.357-.923-.72-1.2-.352-.277-.773-.416-1.264-.416-.555 0-1.013.144-1.376.432-.362.277-.602.672-.72 1.184Zm11.58.656L100.78 37h-2.384l-1.728-2.432L94.925 37H92.54l2.928-4.08-2.8-3.92h2.384l1.616 2.256L98.285 29h2.368l-2.8 3.904Z"
                      fill="#fff"
                    />
                    <path
                      d="M49.614 61.224c-1.099 0-2.027-.245-2.784-.736a4.018 4.018 0 0 1-1.616-2.032l1.888-1.104c.437 1.141 1.296 1.712 2.576 1.712.597 0 1.045-.107 1.344-.32.299-.213.448-.501.448-.864 0-.395-.176-.699-.528-.912-.352-.224-.981-.464-1.888-.72-.981-.299-1.755-.645-2.32-1.04-.704-.523-1.056-1.29-1.056-2.304 0-1.024.357-1.83 1.072-2.416.715-.608 1.584-.912 2.608-.912.896 0 1.69.219 2.384.656.693.437 1.232 1.056 1.616 1.856l-1.856 1.072c-.448-.96-1.163-1.44-2.144-1.44-.448 0-.805.107-1.072.32a.957.957 0 0 0-.4.8c0 .352.144.64.432.864.32.224.885.459 1.696.704l.768.256c.139.043.379.133.72.272.32.117.555.23.704.336.523.32.875.65 1.056.992.277.448.416.976.416 1.584 0 1.035-.379 1.856-1.136 2.464-.757.608-1.733.912-2.928.912ZM59.364 53v1.984h-1.808v3.328c0 .277.07.48.208.608.138.128.341.203.608.224.266.01.597.005.992-.016V61c-1.398.16-2.395.032-2.992-.384-.587-.427-.88-1.195-.88-2.304v-3.328H54.1V53h1.392v-1.616l2.064-.624V53h1.808Zm7.285.944V53h2.064v8h-2.064v-.944c-.619.779-1.488 1.168-2.608 1.168-1.067 0-1.984-.405-2.752-1.216-.757-.821-1.136-1.824-1.136-3.008 0-1.173.379-2.17 1.136-2.992.768-.821 1.685-1.232 2.752-1.232 1.12 0 1.99.39 2.608 1.168Zm-3.808 4.688c.416.416.944.624 1.584.624.64 0 1.168-.208 1.584-.624.427-.427.64-.97.64-1.632 0-.661-.213-1.2-.64-1.616-.416-.427-.944-.64-1.584-.64-.64 0-1.168.213-1.584.64-.416.416-.624.955-.624 1.616 0 .661.208 1.205.624 1.632Zm11.808-1.68L77.96 61h-2.4l-2.912-3.632V61h-2.064V49.8h2.064v6.72L75.4 53h2.464l-3.216 3.952Zm5.366-4.912a1.254 1.254 0 0 1-1.264-1.264c0-.341.123-.64.368-.896.256-.256.555-.384.896-.384.352 0 .65.128.896.384.256.256.384.555.384.896 0 .341-.128.64-.384.896a1.22 1.22 0 0 1-.896.368Zm1.04 8.96H78.99v-8h2.064v8Zm6.337-8.224c.885 0 1.605.293 2.16.88.576.597.864 1.408.864 2.432V61h-2.064v-4.656c0-.523-.144-.928-.432-1.216-.277-.288-.661-.432-1.152-.432-.544 0-.976.17-1.296.512-.31.33-.464.821-.464 1.472V61h-2.064v-8h2.064v.896c.49-.747 1.285-1.12 2.384-1.12Zm10.914 1.216V53h2.016v7.616c0 1.227-.41 2.17-1.232 2.832-.81.65-1.792.976-2.944.976-1.813 0-3.077-.65-3.792-1.952l1.76-1.008c.395.747 1.094 1.12 2.096 1.12.651 0 1.163-.17 1.536-.512.374-.341.56-.827.56-1.456v-.864c-.608.81-1.461 1.216-2.56 1.216-1.13 0-2.08-.395-2.848-1.184-.757-.81-1.136-1.781-1.136-2.912 0-1.13.384-2.096 1.152-2.896.768-.8 1.712-1.2 2.832-1.2 1.099 0 1.952.405 2.56 1.216Zm-.64 4.464c.427-.416.64-.944.64-1.584 0-.64-.213-1.157-.64-1.552-.416-.416-.949-.624-1.6-.624-.64 0-1.178.208-1.616.624-.416.395-.624.912-.624 1.552s.208 1.168.624 1.584c.427.405.966.608 1.616.608.651 0 1.184-.203 1.6-.608Z"
                      fill="#51DDB9"
                    />
                    <g filter="url(#temp-item-text_svg__c)">
                      <mask id="temp-item-text_svg__d" fill="#fff">
                        <path d="M154 154a8 8 0 0 1 8-8h130a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H162a8 8 0 0 1-8-8v-64Z" />
                      </mask>
                      <path
                        d="M154 154a8 8 0 0 1 8-8h130a8 8 0 0 1 8 8v64a8 8 0 0 1-8 8H162a8 8 0 0 1-8-8v-64Z"
                        fill="#3071EE"
                        fillOpacity="0.1"
                      />
                      <path
                        d="M154 146h146-146Zm146 72c0 5.523-4.477 10-10 10H164c-5.523 0-10-4.477-10-10 0 3.314 3.582 6 8 6h130c4.418 0 8-2.686 8-6Zm-146 8v-80 80Zm146-80v80-80Z"
                        fill="#3071EE"
                        mask="url(#temp-item-text_svg__d)"
                      />
                    </g>
                    <path
                      d="M208.861 166.8h2.272V178h-2.192v-7.264l-3.152 5.2h-.256l-3.152-5.184V178h-2.208v-11.2h2.272l3.216 5.296 3.2-5.296Zm10.343 4.144V170h2.064v8h-2.064v-.944c-.619.779-1.488 1.168-2.608 1.168-1.067 0-1.984-.405-2.752-1.216-.758-.821-1.136-1.824-1.136-3.008 0-1.173.378-2.171 1.136-2.992.768-.821 1.685-1.232 2.752-1.232 1.12 0 1.989.389 2.608 1.168Zm-3.808 4.688c.416.416.944.624 1.584.624.64 0 1.168-.208 1.584-.624.426-.427.64-.971.64-1.632 0-.661-.214-1.2-.64-1.616-.416-.427-.944-.64-1.584-.64-.64 0-1.168.213-1.584.64-.416.416-.624.955-.624 1.616 0 .661.208 1.205.624 1.632Zm9.807-5.632v1.376a2.1 2.1 0 0 1 .928-1.136c.438-.267.939-.4 1.504-.4v2.304c-.629-.085-1.194.043-1.696.384-.49.331-.736.88-.736 1.648V178h-2.064v-8h2.064Zm9.471.992V170h2.016v7.616c0 1.227-.411 2.171-1.232 2.832-.811.651-1.792.976-2.944.976-1.814 0-3.078-.651-3.792-1.952l1.76-1.008c.394.747 1.093 1.12 2.096 1.12.65 0 1.162-.171 1.536-.512.373-.341.56-.827.56-1.456v-.864c-.608.811-1.462 1.216-2.56 1.216-1.131 0-2.08-.395-2.848-1.184-.758-.811-1.136-1.781-1.136-2.912s.384-2.096 1.152-2.896c.768-.8 1.712-1.2 2.832-1.2 1.098 0 1.952.405 2.56 1.216Zm-.64 4.464c.426-.416.64-.944.64-1.584 0-.64-.214-1.157-.64-1.552-.416-.416-.95-.624-1.6-.624-.64 0-1.179.208-1.616.624-.416.395-.624.912-.624 1.552s.208 1.168.624 1.584c.426.405.965.608 1.616.608.65 0 1.184-.203 1.6-.608Zm12.303-.608h-6.032c.267 1.003 1.019 1.504 2.256 1.504.79 0 1.387-.267 1.792-.8l1.664.96c-.789 1.141-1.952 1.712-3.488 1.712-1.322 0-2.384-.4-3.184-1.2-.8-.8-1.2-1.808-1.2-3.024 0-1.195.395-2.197 1.184-3.008.779-.811 1.792-1.216 3.04-1.216 1.184 0 2.15.405 2.896 1.216.768.811 1.152 1.813 1.152 3.008 0 .224-.026.507-.08.848Zm-6.064-1.6h4.08c-.117-.523-.357-.923-.72-1.2-.352-.277-.773-.416-1.264-.416-.554 0-1.013.144-1.376.432-.362.277-.602.672-.72 1.184Zm11.58.656 2.928 4.096h-2.384l-1.728-2.432-1.744 2.432h-2.384l2.928-4.08-2.8-3.92h2.384l1.616 2.256 1.616-2.256h2.368l-2.8 3.904Z"
                      fill="#fff"
                    />
                    <path
                      d="M199.075 190.8h8.24v2.112h-3.024V202h-2.208v-9.088h-3.008V190.8ZM209.5 194v1.376a2.1 2.1 0 0 1 .928-1.136c.438-.267.939-.4 1.504-.4v2.304c-.629-.085-1.194.043-1.696.384-.49.331-.736.88-.736 1.648V202h-2.064v-8h2.064Zm9.422.944V194h2.064v8h-2.064v-.944c-.618.779-1.488 1.168-2.608 1.168-1.066 0-1.984-.405-2.752-1.216-.757-.821-1.136-1.824-1.136-3.008 0-1.173.379-2.171 1.136-2.992.768-.821 1.686-1.232 2.752-1.232 1.12 0 1.99.389 2.608 1.168Zm-3.808 4.688c.416.416.944.624 1.584.624.64 0 1.168-.208 1.584-.624.427-.427.64-.971.64-1.632 0-.661-.213-1.2-.64-1.616-.416-.427-.944-.64-1.584-.64-.64 0-1.168.213-1.584.64-.416.416-.624.955-.624 1.616 0 .661.208 1.205.624 1.632Zm13.808-4.688V190.8h2.064V202h-2.064v-.944c-.608.779-1.472 1.168-2.592 1.168-1.077 0-2-.405-2.768-1.216-.757-.821-1.136-1.824-1.136-3.008 0-1.173.379-2.171 1.136-2.992.768-.821 1.691-1.232 2.768-1.232 1.12 0 1.984.389 2.592 1.168Zm-3.808 4.688c.437.416.971.624 1.6.624.64 0 1.168-.208 1.584-.624.416-.427.624-.971.624-1.632 0-.661-.208-1.2-.624-1.616-.416-.427-.944-.64-1.584-.64-.64 0-1.173.213-1.6.64-.416.416-.624.955-.624 1.616 0 .661.208 1.205.624 1.632Zm8.784-6.592a1.255 1.255 0 0 1-1.264-1.264c0-.341.122-.64.368-.896.256-.256.554-.384.896-.384.352 0 .65.128.896.384.256.256.384.555.384.896 0 .341-.128.64-.384.896a1.222 1.222 0 0 1-.896.368Zm1.04 8.96h-2.064v-8h2.064v8Zm6.337-8.224c.885 0 1.605.293 2.16.88.576.597.864 1.408.864 2.432V202h-2.064v-4.656c0-.523-.144-.928-.432-1.216-.278-.288-.662-.432-1.152-.432-.544 0-.976.171-1.296.512-.31.331-.464.821-.464 1.472V202h-2.064v-8h2.064v.896c.49-.747 1.285-1.12 2.384-1.12Zm10.914 1.216V194h2.016v7.616c0 1.227-.41 2.171-1.232 2.832-.81.651-1.792.976-2.944.976-1.813 0-3.077-.651-3.792-1.952l1.76-1.008c.395.747 1.094 1.12 2.096 1.12.651 0 1.163-.171 1.536-.512.374-.341.56-.827.56-1.456v-.864c-.608.811-1.461 1.216-2.56 1.216-1.13 0-2.08-.395-2.848-1.184-.757-.811-1.136-1.781-1.136-2.912s.384-2.096 1.152-2.896c.768-.8 1.712-1.2 2.832-1.2 1.099 0 1.952.405 2.56 1.216Zm-.64 4.464c.427-.416.64-.944.64-1.584 0-.64-.213-1.157-.64-1.552-.416-.416-.949-.624-1.6-.624-.64 0-1.178.208-1.616.624-.416.395-.624.912-.624 1.552s.208 1.168.624 1.584c.427.405.966.608 1.616.608.651 0 1.184-.203 1.6-.608Z"
                      fill="#3071EE"
                    />
                    <path
                      d="M218.017 13.8h2.496l-3.84 6.832V25h-2.192v-4.368l-3.824-6.832h2.496l2.432 4.672 2.432-4.672Zm8.696 10.208c-.811.81-1.813 1.216-3.008 1.216s-2.197-.405-3.008-1.216c-.811-.81-1.216-1.813-1.216-3.008 0-1.184.405-2.181 1.216-2.992.821-.821 1.824-1.232 3.008-1.232s2.187.41 3.008 1.232c.821.821 1.232 1.819 1.232 2.992 0 1.184-.411 2.187-1.232 3.008Zm-4.56-1.424c.416.416.933.624 1.552.624s1.136-.208 1.552-.624c.416-.416.624-.944.624-1.584 0-.64-.208-1.168-.624-1.584-.416-.416-.933-.624-1.552-.624s-1.136.208-1.552.624c-.405.427-.608.955-.608 1.584 0 .63.203 1.157.608 1.584Zm12.524-1.264V17h2.064v8h-2.064v-.896c-.491.747-1.285 1.12-2.384 1.12-.875 0-1.6-.293-2.176-.88-.565-.597-.848-1.408-.848-2.432V17h2.064v4.656c0 .523.139.928.416 1.216.288.288.677.432 1.168.432.544 0 .971-.165 1.28-.496.32-.341.48-.837.48-1.488Zm6.019-4.32v1.376c.181-.501.49-.88.928-1.136.437-.267.938-.4 1.504-.4v2.304c-.63-.085-1.195.043-1.696.384-.491.33-.736.88-.736 1.648V25h-2.064v-8h2.064Zm-37.082 32.224c-1.099 0-2.027-.245-2.784-.736a4.02 4.02 0 0 1-1.616-2.032l1.888-1.104c.437 1.141 1.296 1.712 2.576 1.712.597 0 1.045-.107 1.344-.32.299-.213.448-.501.448-.864 0-.395-.176-.699-.528-.912-.352-.224-.981-.464-1.888-.72-.981-.299-1.755-.645-2.32-1.04-.704-.523-1.056-1.29-1.056-2.304 0-1.024.357-1.83 1.072-2.416.715-.608 1.584-.912 2.608-.912.896 0 1.691.219 2.384.656.693.437 1.232 1.056 1.616 1.856l-1.856 1.072c-.448-.96-1.163-1.44-2.144-1.44-.448 0-.805.107-1.072.32a.956.956 0 0 0-.4.8c0 .352.144.64.432.864.32.224.885.459 1.696.704l.768.256c.139.043.379.133.72.272.32.117.555.23.704.336.523.32.875.65 1.056.992.277.448.416.976.416 1.584 0 1.035-.379 1.856-1.136 2.464-.757.608-1.733.912-2.928.912Zm9.75-8.224v1.984h-1.808v3.328c0 .277.069.48.208.608.138.128.341.203.608.224.266.01.597.005.992-.016V49c-1.398.16-2.395.032-2.992-.384-.587-.427-.88-1.195-.88-2.304v-3.328H208.1V41h1.392v-1.616l2.064-.624V41h1.808Zm7.285.944V41h2.064v8h-2.064v-.944c-.619.779-1.488 1.168-2.608 1.168-1.067 0-1.984-.405-2.752-1.216-.757-.821-1.136-1.824-1.136-3.008 0-1.173.379-2.17 1.136-2.992.768-.821 1.685-1.232 2.752-1.232 1.12 0 1.989.39 2.608 1.168Zm-3.808 4.688c.416.416.944.624 1.584.624.64 0 1.168-.208 1.584-.624.427-.427.64-.97.64-1.632 0-.661-.213-1.2-.64-1.616-.416-.427-.944-.64-1.584-.64-.64 0-1.168.213-1.584.64-.416.416-.624.955-.624 1.616 0 .661.208 1.205.624 1.632Zm11.808-1.68L231.961 49h-2.4l-2.912-3.632V49h-2.064V37.8h2.064v6.72l2.752-3.52h2.464l-3.216 3.952Zm5.366-4.912a1.255 1.255 0 0 1-1.264-1.264c0-.341.123-.64.368-.896.256-.256.555-.384.896-.384.352 0 .651.128.896.384.256.256.384.555.384.896 0 .341-.128.64-.384.896a1.219 1.219 0 0 1-.896.368Zm1.04 8.96h-2.064v-8h2.064v8Zm6.337-8.224c.885 0 1.605.293 2.16.88.576.597.864 1.408.864 2.432V49h-2.064v-4.656c0-.523-.144-.928-.432-1.216-.277-.288-.661-.432-1.152-.432-.544 0-.976.17-1.296.512-.309.33-.464.821-.464 1.472V49h-2.064v-8h2.064v.896c.491-.747 1.285-1.12 2.384-1.12Zm10.914 1.216V41h2.016v7.616c0 1.227-.41 2.17-1.232 2.832-.81.65-1.792.976-2.944.976-1.813 0-3.077-.65-3.792-1.952l1.76-1.008c.395.747 1.094 1.12 2.096 1.12.651 0 1.163-.17 1.536-.512.374-.341.56-.827.56-1.456v-.864c-.608.81-1.461 1.216-2.56 1.216-1.13 0-2.08-.395-2.848-1.184-.757-.81-1.136-1.781-1.136-2.912 0-1.13.384-2.096 1.152-2.896.768-.8 1.712-1.2 2.832-1.2 1.099 0 1.952.405 2.56 1.216Zm-.64 4.464c.427-.416.64-.944.64-1.584 0-.64-.213-1.157-.64-1.552-.416-.416-.949-.624-1.6-.624-.64 0-1.178.208-1.616.624-.416.395-.624.912-.624 1.552s.208 1.168.624 1.584c.427.405.966.608 1.616.608.651 0 1.184-.203 1.6-.608ZM201.968 64.04a1.255 1.255 0 0 1-1.264-1.264c0-.341.123-.64.368-.896.256-.256.555-.384.896-.384.352 0 .651.128.896.384.256.256.384.555.384.896 0 .341-.128.64-.384.896a1.219 1.219 0 0 1-.896.368Zm1.04 8.96h-2.064v-8h2.064v8Zm6.337-8.224c.885 0 1.605.293 2.16.88.576.597.864 1.408.864 2.432V73h-2.064v-4.656c0-.523-.144-.928-.432-1.216-.277-.288-.661-.432-1.152-.432-.544 0-.976.17-1.296.512-.309.33-.464.821-.464 1.472V73h-2.064v-8h2.064v.896c.491-.747 1.285-1.12 2.384-1.12Zm8.595 8.448c-1.206 0-2.214-.405-3.024-1.216-.8-.81-1.201-1.813-1.201-3.008s.401-2.197 1.201-3.008c.81-.81 1.818-1.216 3.024-1.216.778 0 1.488.187 2.128.56.64.373 1.125.875 1.456 1.504l-1.776 1.04a1.802 1.802 0 0 0-.736-.784 2.074 2.074 0 0 0-1.088-.288c-.619 0-1.131.208-1.536.624-.406.405-.608.928-.608 1.568 0 .619.202 1.141.608 1.568.405.405.917.608 1.536.608a2.2 2.2 0 0 0 1.104-.272c.33-.192.576-.453.736-.784l1.792 1.024a3.89 3.89 0 0 1-1.504 1.52c-.64.373-1.344.56-2.112.56Zm11.398-1.216c-.811.81-1.813 1.216-3.008 1.216s-2.197-.405-3.008-1.216c-.811-.81-1.216-1.813-1.216-3.008 0-1.184.405-2.181 1.216-2.992.821-.821 1.824-1.232 3.008-1.232s2.187.41 3.008 1.232c.821.821 1.232 1.819 1.232 2.992 0 1.184-.411 2.187-1.232 3.008Zm-4.56-1.424c.416.416.933.624 1.552.624s1.136-.208 1.552-.624c.416-.416.624-.944.624-1.584 0-.64-.208-1.168-.624-1.584-.416-.416-.933-.624-1.552-.624s-1.136.208-1.552.624c-.405.427-.608.955-.608 1.584 0 .63.203 1.157.608 1.584Zm16.092-5.808c.917 0 1.648.299 2.192.896.555.597.832 1.397.832 2.4V73h-2.064v-4.784c0-.48-.117-.853-.352-1.12-.235-.267-.565-.4-.992-.4-.469 0-.837.155-1.104.464-.256.31-.384.757-.384 1.344V73h-2.064v-4.784c0-.48-.117-.853-.352-1.12-.235-.267-.565-.4-.992-.4-.459 0-.827.16-1.104.48-.267.31-.4.752-.4 1.328V73h-2.064v-8h2.064v.848c.48-.715 1.221-1.072 2.224-1.072.992 0 1.717.384 2.176 1.152.523-.768 1.317-1.152 2.384-1.152Zm12.553 5.072h-6.032c.267 1.003 1.019 1.504 2.256 1.504.789 0 1.387-.267 1.792-.8l1.664.96c-.789 1.141-1.952 1.712-3.488 1.712-1.323 0-2.384-.4-3.184-1.2-.8-.8-1.2-1.808-1.2-3.024 0-1.195.395-2.197 1.184-3.008.779-.81 1.792-1.216 3.04-1.216 1.184 0 2.149.405 2.896 1.216.768.81 1.152 1.813 1.152 3.008 0 .224-.027.507-.08.848Zm-6.064-1.6h4.08c-.117-.523-.357-.923-.72-1.2-.352-.277-.773-.416-1.264-.416-.555 0-1.013.144-1.376.432-.363.277-.603.672-.72 1.184ZM64.017 154.8h2.496l-3.84 6.832V166h-2.192v-4.368l-3.824-6.832h2.496l2.432 4.672 2.432-4.672Zm8.696 10.208c-.81.811-1.813 1.216-3.008 1.216s-2.197-.405-3.008-1.216c-.81-.811-1.216-1.813-1.216-3.008 0-1.184.406-2.181 1.216-2.992.822-.821 1.824-1.232 3.008-1.232s2.187.411 3.008 1.232c.822.821 1.232 1.819 1.232 2.992 0 1.184-.41 2.187-1.232 3.008Zm-4.56-1.424c.416.416.933.624 1.552.624s1.136-.208 1.552-.624c.416-.416.624-.944.624-1.584 0-.64-.208-1.168-.624-1.584-.416-.416-.933-.624-1.552-.624-.618 0-1.136.208-1.552.624-.405.427-.608.955-.608 1.584 0 .629.203 1.157.608 1.584Zm12.524-1.264V158h2.064v8h-2.064v-.896c-.49.747-1.285 1.12-2.384 1.12-.875 0-1.6-.293-2.176-.88-.565-.597-.848-1.408-.848-2.432V158h2.064v4.656c0 .523.139.928.416 1.216.288.288.678.432 1.168.432.544 0 .97-.165 1.28-.496.32-.341.48-.837.48-1.488Zm6.018-4.32v1.376c.182-.501.491-.88.929-1.136.437-.267.938-.4 1.504-.4v2.304c-.63-.085-1.195.043-1.697.384-.49.331-.736.88-.736 1.648V166h-2.063v-8h2.063Zm-41.62 20.8h8.24v2.112h-3.024V190h-2.208v-9.088h-3.008V178.8ZM55.5 182v1.376c.181-.501.49-.88.928-1.136.438-.267.939-.4 1.504-.4v2.304c-.63-.085-1.195.043-1.696.384-.49.331-.736.88-.736 1.648V190h-2.064v-8H55.5Zm9.422.944V182h2.064v8h-2.064v-.944c-.618.779-1.488 1.168-2.608 1.168-1.066 0-1.984-.405-2.752-1.216-.757-.821-1.136-1.824-1.136-3.008 0-1.173.38-2.171 1.136-2.992.768-.821 1.686-1.232 2.752-1.232 1.12 0 1.99.389 2.608 1.168Zm-3.808 4.688c.416.416.944.624 1.584.624.64 0 1.168-.208 1.584-.624.427-.427.64-.971.64-1.632 0-.661-.213-1.2-.64-1.616-.416-.427-.944-.64-1.584-.64-.64 0-1.168.213-1.584.64-.416.416-.624.955-.624 1.616 0 .661.208 1.205.624 1.632Zm13.808-4.688V178.8h2.064V190h-2.064v-.944c-.608.779-1.472 1.168-2.592 1.168-1.077 0-2-.405-2.768-1.216-.757-.821-1.136-1.824-1.136-3.008 0-1.173.379-2.171 1.136-2.992.768-.821 1.69-1.232 2.768-1.232 1.12 0 1.984.389 2.592 1.168Zm-3.808 4.688c.437.416.97.624 1.6.624.64 0 1.168-.208 1.584-.624.416-.427.624-.971.624-1.632 0-.661-.208-1.2-.624-1.616-.416-.427-.944-.64-1.584-.64-.64 0-1.173.213-1.6.64-.416.416-.624.955-.624 1.616 0 .661.208 1.205.624 1.632Zm8.784-6.592a1.256 1.256 0 0 1-1.264-1.264c0-.341.122-.64.368-.896.256-.256.554-.384.896-.384.352 0 .65.128.896.384.256.256.384.555.384.896 0 .341-.128.64-.384.896a1.22 1.22 0 0 1-.896.368Zm1.04 8.96h-2.064v-8h2.064v8Zm6.337-8.224c.885 0 1.605.293 2.16.88.576.597.864 1.408.864 2.432V190h-2.064v-4.656c0-.523-.144-.928-.432-1.216-.278-.288-.662-.432-1.152-.432-.544 0-.976.171-1.296.512-.31.331-.464.821-.464 1.472V190h-2.064v-8h2.064v.896c.49-.747 1.285-1.12 2.384-1.12Zm10.914 1.216V182h2.016v7.616c0 1.227-.41 2.171-1.232 2.832-.81.651-1.792.976-2.944.976-1.813 0-3.077-.651-3.792-1.952l1.76-1.008c.395.747 1.094 1.12 2.096 1.12.65 0 1.163-.171 1.536-.512.373-.341.56-.827.56-1.456v-.864c-.608.811-1.461 1.216-2.56 1.216-1.13 0-2.08-.395-2.848-1.184-.757-.811-1.136-1.781-1.136-2.912s.384-2.096 1.152-2.896c.768-.8 1.712-1.2 2.832-1.2 1.099 0 1.952.405 2.56 1.216Zm-.64 4.464c.427-.416.64-.944.64-1.584 0-.64-.213-1.157-.64-1.552-.416-.416-.95-.624-1.6-.624-.64 0-1.178.208-1.616.624-.416.395-.624.912-.624 1.552s.208 1.168.624 1.584c.427.405.966.608 1.616.608.65 0 1.184-.203 1.6-.608ZM47.968 205.04a1.256 1.256 0 0 1-1.264-1.264c0-.341.123-.64.368-.896.256-.256.555-.384.896-.384.352 0 .65.128.896.384.256.256.384.555.384.896 0 .341-.128.64-.384.896a1.22 1.22 0 0 1-.896.368Zm1.04 8.96h-2.064v-8h2.064v8Zm6.337-8.224c.886 0 1.605.293 2.16.88.576.597.864 1.408.864 2.432V214h-2.064v-4.656c0-.523-.144-.928-.432-1.216-.277-.288-.661-.432-1.152-.432-.544 0-.976.171-1.296.512-.31.331-.464.821-.464 1.472V214h-2.064v-8h2.064v.896c.49-.747 1.285-1.12 2.384-1.12Zm8.595 8.448c-1.206 0-2.214-.405-3.024-1.216-.8-.811-1.2-1.813-1.2-3.008s.4-2.197 1.2-3.008c.81-.811 1.818-1.216 3.024-1.216a4.15 4.15 0 0 1 2.127.56c.64.373 1.126.875 1.457 1.504l-1.776 1.04a1.796 1.796 0 0 0-.737-.784 2.073 2.073 0 0 0-1.087-.288c-.62 0-1.131.208-1.536.624-.406.405-.608.928-.608 1.568 0 .619.202 1.141.608 1.568.405.405.917.608 1.535.608.416 0 .784-.091 1.105-.272.33-.192.575-.453.735-.784l1.792 1.024a3.884 3.884 0 0 1-1.504 1.52 4.12 4.12 0 0 1-2.111.56Zm11.398-1.216c-.81.811-1.813 1.216-3.008 1.216s-2.197-.405-3.008-1.216c-.81-.811-1.216-1.813-1.216-3.008 0-1.184.406-2.181 1.216-2.992.822-.821 1.824-1.232 3.008-1.232s2.187.411 3.008 1.232c.822.821 1.232 1.819 1.232 2.992 0 1.184-.41 2.187-1.232 3.008Zm-4.56-1.424c.416.416.933.624 1.552.624s1.136-.208 1.552-.624c.416-.416.624-.944.624-1.584 0-.64-.208-1.168-.624-1.584-.416-.416-.933-.624-1.552-.624-.618 0-1.136.208-1.552.624-.405.427-.608.955-.608 1.584 0 .629.203 1.157.608 1.584Zm16.092-5.808c.917 0 1.648.299 2.192.896.555.597.832 1.397.832 2.4V214H87.83v-4.784c0-.48-.117-.853-.352-1.12-.234-.267-.565-.4-.992-.4-.47 0-.837.155-1.104.464-.256.309-.384.757-.384 1.344V214h-2.064v-4.784c0-.48-.117-.853-.352-1.12-.234-.267-.565-.4-.992-.4-.459 0-.827.16-1.104.48-.267.309-.4.752-.4 1.328V214h-2.064v-8h2.064v.848c.48-.715 1.222-1.072 2.224-1.072.992 0 1.718.384 2.176 1.152.523-.768 1.317-1.152 2.384-1.152Zm12.553 5.072h-6.032c.267 1.003 1.019 1.504 2.256 1.504.79 0 1.387-.267 1.792-.8l1.664.96c-.79 1.141-1.952 1.712-3.488 1.712-1.322 0-2.384-.4-3.184-1.2-.8-.8-1.2-1.808-1.2-3.024 0-1.195.395-2.197 1.184-3.008.779-.811 1.792-1.216 3.04-1.216 1.184 0 2.15.405 2.896 1.216.768.811 1.152 1.813 1.152 3.008 0 .224-.026.507-.08.848Zm-6.064-1.6h4.08c-.117-.523-.357-.923-.72-1.2-.352-.277-.773-.416-1.264-.416-.555 0-1.013.144-1.376.432-.362.277-.602.672-.72 1.184Z"
                      fill="#fff"
                    />
                    <path
                      d="M140.667 45a5.333 5.333 0 1 0 10.666 0 5.333 5.333 0 1 0-10.666 0ZM183 45l-10-5.773v11.547L183 45Zm-37 1h28v-2h-28v2Z"
                      fill="#51DDB9"
                    />
                    <path
                      d="M148.667 186a5.332 5.332 0 0 0 5.333 5.333 5.332 5.332 0 0 0 5.333-5.333 5.332 5.332 0 0 0-5.333-5.333 5.332 5.332 0 0 0-5.333 5.333ZM117 186l10 5.774v-11.548L117 186Zm37-1h-28v2h28v-2Z"
                      fill="#3071EE"
                    />
                    <path
                      d="M227 84.227 221.226 90 227 95.773 232.774 90 227 84.227ZM227 142l5.774-10h-11.548L227 142Zm-1-52v43h2V90h-2Z"
                      fill="#51DDB9"
                    />
                    <path
                      d="M73 146.774 78.773 141 73 135.226 67.227 141 73 146.774ZM73 89l-5.773 10h11.546L73 89Zm1 52V98h-2v43h2Z"
                      fill="#3071EE"
                    />
                    <defs>
                      <filter
                        id="temp-item-text_svg__a"
                        x={-40}
                        y={-35}
                        width={226}
                        height={160}
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity={0} result="BackgroundImageFix" />
                        <feGaussianBlur
                          in="BackgroundImage"
                          stdDeviation={20}
                        />
                        <feComposite
                          in2="SourceAlpha"
                          operator="in"
                          result="effect1_backgroundBlur_767_10181"
                        ></feComposite>
                        <feBlend
                          in="SourceGraphic"
                          in2="effect1_backgroundBlur_767_10181"
                          result="shape"
                        />
                      </filter>
                      <filter
                        id="temp-item-text_svg__c"
                        x={114}
                        y={106}
                        width={226}
                        height={160}
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity={0} result="BackgroundImageFix" />
                        <feGaussianBlur
                          in="BackgroundImage"
                          stdDeviation={20}
                        />
                        <feComposite
                          in2="SourceAlpha"
                          operator="in"
                          result="effect1_backgroundBlur_767_10181"
                        ></feComposite>
                        <feBlend
                          in="SourceGraphic"
                          in2="effect1_backgroundBlur_767_10181"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
              </div>
            </section>
            <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 hXWeeJ">
              <div className="Container-sc-rx245t-0 dGblwP">
                <h2 className="Heading-sc-vfylp7-0 jJrhee">
                  Earn an honest 5% in rewards
                </h2>
                <p className="Subheading-sc-t8ooc1-0 ihSfAf">
                  {siteSettings.siteName} protects clients from price
                  manipulation using MP Shield, enabling an honest,
                  high-percentage yield on staking pools. Trade, stake, and
                  access the best possible returns in the market with no
                  restrictions, 24/7, 365 days a year.
                </p>
                <div className="Speedometers__SpeedometersBlock-sc-5off5-0 dXYoqz">
                  <div className="Speedometers__SpeedometerWrapper-sc-5off5-1 umbKs">
                    <h3 className="Speedometers__Title-sc-5off5-2 jEvmzE">
                      <span>{siteSettings.siteName}</span> Staking
                    </h3>
                    <div className="Speedometer__SpeedometerContainer-sc-1frto4m-0 hMZmXB">
                      <svg
                        width={421}
                        height={236}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 420 235"
                        className="Speedometers__SpeedometerSvg1Wrapper-sc-5off5-3 dHUOMy"
                      >
                        <g clipPath="url(#speedometer1_svg__a)">
                          <circle
                            cx="210.529"
                            cy={210}
                            r={209}
                            fill="url(#speedometer1_svg__b)"
                          />
                          <path
                            d="M339.529 210c37.003 0 68.064 30.841 55.66 65.703a195.997 195.997 0 0 1-144.913 126.225A196.002 196.002 0 0 1 17.058 178.616c5.925-36.526 48.002-48.589 80.428-30.762l97.968 53.859A67.013 67.013 0 0 0 227.732 210h111.797Z"
                            fill="url(#speedometer1_svg__c)"
                          />
                          <circle
                            cx="210.529"
                            cy={210}
                            r={206}
                            stroke="url(#speedometer1_svg__d)"
                            strokeWidth={6}
                          ></circle>
                          <circle
                            cx="210.529"
                            cy={210}
                            r={140}
                            stroke="url(#speedometer1_svg__e)"
                            strokeWidth={12}
                          ></circle>
                          <path
                            d="M22.416 200.603h2.4v14h-2.76v-11.08l-2.64.74-.68-2.36 3.68-1.3Zm10.514 5.38c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM379.812 200.603h2.4v14h-2.76v-11.08l-2.64.74-.68-2.36 3.68-1.3Zm7.734 0h2.4v14h-2.76v-11.08l-2.64.74-.68-2.36 3.68-1.3Zm10.515 5.38c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.128 1.128 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM26.958 157v-2.06l4.78-4.92c1.067-1.12 1.6-2.053 1.6-2.8 0-.547-.173-.987-.52-1.32-.333-.333-.767-.5-1.3-.5-1.053 0-1.833.547-2.34 1.64l-2.32-1.36c.44-.96 1.073-1.693 1.9-2.2a5.103 5.103 0 0 1 2.72-.76c1.267 0 2.353.4 3.26 1.2.907.787 1.36 1.853 1.36 3.2 0 1.453-.767 2.947-2.3 4.48l-2.74 2.74h5.26V157h-9.36Zm16.57-8.62c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM379.705 147.58c0 1.08-.28 2.027-.84 2.84h.02l-4.36 6.58h-3.16l3.12-4.56c-1.453-.027-2.64-.487-3.56-1.38-.906-.907-1.36-2.067-1.36-3.48 0-1.427.467-2.593 1.4-3.5.947-.907 2.167-1.36 3.66-1.36 1.507 0 2.727.453 3.66 1.36.947.893 1.42 2.06 1.42 3.5Zm-7.4 0c0 .693.22 1.247.66 1.66.454.413 1.007.62 1.66.62.68 0 1.24-.207 1.68-.62.44-.413.66-.967.66-1.66s-.22-1.24-.66-1.64c-.44-.413-1-.62-1.68-.62-.653 0-1.206.207-1.66.62-.44.413-.66.96-.66 1.64Zm14.535.8c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.128 1.128 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM63.796 93.68c.947.28 1.714.773 2.3 1.48.6.693.9 1.533.9 2.52 0 1.44-.486 2.567-1.46 3.38-.96.813-2.14 1.22-3.54 1.22-1.093 0-2.073-.247-2.94-.74-.853-.507-1.473-1.247-1.86-2.22l2.36-1.36c.347 1.08 1.16 1.62 2.44 1.62.707 0 1.254-.167 1.64-.5.4-.347.6-.813.6-1.4 0-.573-.2-1.033-.6-1.38-.386-.347-.933-.52-1.64-.52h-.6l-1.06-1.6 2.76-3.6h-5.48V88h8.8v2.28l-2.62 3.4Zm9.913-.3c-.64.627-1.44.94-2.4.94s-1.766-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.654-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.226.24-.34.54-.34.9s.114.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.654-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.126 1.126 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.226.24-.34.54-.34.9s.114.667.34.92ZM349.274 94.72c1.293.773 1.94 1.9 1.94 3.38 0 1.293-.454 2.313-1.36 3.06-.894.747-2.114 1.12-3.66 1.12-1.56 0-2.787-.373-3.68-1.12-.894-.747-1.34-1.767-1.34-3.06 0-1.48.64-2.607 1.92-3.38-.974-.707-1.46-1.673-1.46-2.9 0-1.293.433-2.3 1.3-3.02.88-.72 1.966-1.08 3.26-1.08 1.293 0 2.373.36 3.24 1.08.866.72 1.3 1.727 1.3 3.02 0 1.24-.487 2.207-1.46 2.9Zm-1.78-3.96c-.334-.293-.767-.44-1.3-.44-.534 0-.967.147-1.3.44-.334.293-.5.693-.5 1.2s.166.913.5 1.22c.333.293.766.44 1.3.44.533 0 .966-.147 1.3-.44.333-.307.5-.713.5-1.22s-.167-.907-.5-1.2Zm-2.96 8.42c.426.333.98.5 1.66.5.68 0 1.226-.167 1.64-.5.426-.347.64-.827.64-1.44 0-.6-.214-1.067-.64-1.4-.414-.347-.96-.52-1.64-.52-.68 0-1.234.173-1.66.52-.414.333-.62.8-.62 1.4 0 .613.206 1.093.62 1.44Zm13.636-5.8c-.64.627-1.44.94-2.4.94s-1.766-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.654-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.226.24-.34.54-.34.9s.114.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.654-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.125 1.125 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.226.24-.34.54-.34.9s.114.667.34.92ZM117.9 55.06v2.56h-1.5V60h-2.78v-2.38H107v-2.56l4.66-9.06h2.96l-4.64 9.06h3.64v-3.32h2.78v3.32h1.5Zm5.966-3.68c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM289.24 46h9.04v2.34L293.54 60h-2.92l4.6-11.36h-5.98V46Zm16.225 5.38c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM171.2 30.1c1.346 0 2.48.407 3.4 1.22.92.8 1.38 1.92 1.38 3.36s-.487 2.567-1.46 3.38c-.96.813-2.14 1.22-3.54 1.22-1.134 0-2.134-.253-3-.76-.867-.507-1.494-1.253-1.88-2.24l2.36-1.38c.346 1.12 1.186 1.68 2.52 1.68.706 0 1.253-.167 1.64-.5.4-.347.6-.813.6-1.4 0-.573-.194-1.033-.58-1.38-.387-.347-.914-.52-1.58-.52h-4.24l.56-7.78h7.94v2.58h-5.38l-.18 2.52h1.44Zm11.646.28c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM234.358 29.54c1.454.04 2.634.513 3.54 1.42.907.893 1.36 2.04 1.36 3.44 0 1.427-.473 2.6-1.42 3.52-.946.907-2.166 1.36-3.66 1.36-1.493 0-2.713-.453-3.66-1.36-.933-.907-1.4-2.08-1.4-3.52 0-1.067.274-2.007.82-2.82l4.36-6.58h3.16l-3.1 4.54Zm-1.84 6.52c.44.413.994.62 1.66.62.667 0 1.22-.207 1.66-.62.454-.413.68-.967.68-1.66 0-.68-.226-1.227-.68-1.64-.44-.413-.993-.62-1.66-.62-.666 0-1.22.207-1.66.62-.44.4-.66.947-.66 1.64s.22 1.247.66 1.66Zm13.269-5.68c-.64.627-1.44.94-2.4.94s-1.766-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.654-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.226.24-.34.54-.34.9s.114.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.654-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.125 1.125 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.226.24-.34.54-.34.9s.114.667.34.92Z"
                            fill="#fff"
                          />
                          <g
                            opacity="0.2"
                            clipPath="url(#speedometer1_svg__f)"
                            stroke="#fff"
                            strokeMiterlimit={10}
                          >
                            <path d="M50.53 209.628h8.93M60.54 153.743l8.371 3.121M88.162 106.447l6.824 5.765M129.77 71.35l4.517 7.717M181.773 52.067l1.593 8.797M239.284 52.067l-1.593 8.797M291.289 71.35l-4.518 7.717M332.896 106.447l-6.824 5.765M360.521 153.743l-8.373 3.121M370.53 209.628h-8.93"></path>
                          </g>
                          <circle cx="210.529" cy={208} r={27} fill="#fff" />
                        </g>
                        <defs>
                          <linearGradient
                            id="speedometer1_svg__b"
                            x1="210.529"
                            y1={-124}
                            x2="210.529"
                            y2={210}
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#08204F" />
                            <stop
                              offset={1}
                              stopColor="#08204F"
                              stopOpacity={0}
                            />
                          </linearGradient>
                          <linearGradient
                            id="speedometer1_svg__c"
                            x1="210.529"
                            y1="-103.225"
                            x2="210.529"
                            y2={210}
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#3071EE" />
                            <stop
                              offset={1}
                              stopColor="#3071EE"
                              stopOpacity={0}
                            />
                          </linearGradient>
                          <linearGradient
                            id="speedometer1_svg__d"
                            x1="210.529"
                            y1={1}
                            x2="210.529"
                            y2={210}
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#3071EE" />
                            <stop
                              offset={1}
                              stopColor="#3071EE"
                              stopOpacity={0}
                            />
                          </linearGradient>
                          <linearGradient
                            id="speedometer1_svg__e"
                            x1="210.529"
                            y1={64}
                            x2="210.529"
                            y2={210}
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#3071EE" />
                            <stop
                              offset={1}
                              stopColor="#3071EE"
                              stopOpacity={0}
                            />
                          </linearGradient>
                          <clipPath id="speedometer1_svg__a">
                            <path
                              fill="#fff"
                              transform="translate(.53)"
                              d="M0 0h420v236H0z"
                            />
                          </clipPath>
                          <clipPath id="speedometer1_svg__f">
                            <path
                              fill="#fff"
                              transform="translate(50.53 52)"
                              d="M0 0h320v158H0z"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div className="Oval-sc-1dczjpv-0 Speedometer__OvalWrapper-sc-1frto4m-1 bqJIBA lcmpHk" />
                      <div className="Speedometer__ArrowWrapper-sc-1frto4m-2 BPvCf" />
                    </div>
                    <p className="Speedometers__Text-sc-5off5-5 iRIcBm">
                      APY: <span>5%</span>
                    </p>
                  </div>
                  <div className="Speedometers__SpeedometerWrapper-sc-5off5-1 umbKs">
                    <h3 className="Speedometers__Title-sc-5off5-2 jEvmzE">
                      <span>Competitors</span> Staking
                    </h3>
                    <div className="Speedometer__SpeedometerContainer-sc-1frto4m-0 hMZmXB">
                      <svg
                        width={421}
                        height={236}
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 420 235"
                        className="Speedometers__SpeedometerSvg2Wrapper-sc-5off5-4 lgjVom"
                      >
                        <g clipPath="url(#speedometer2_svg__a)">
                          <circle
                            cx="210.471"
                            cy={210}
                            r={209}
                            fill="url(#speedometer2_svg__b)"
                          />
                          <path
                            d="M339.471 210c37.003 0 68.063 30.841 55.659 65.703a195.986 195.986 0 0 1-64.53 89.167 195.993 195.993 0 0 1-168.873 34.972A196 196 0 0 1 17 178.616C22.925 142.09 65 130.027 97.427 147.854l97.969 53.859A67.006 67.006 0 0 0 227.673 210h111.798Z"
                            fill="url(#speedometer2_svg__c)"
                          />
                          <circle
                            cx="210.471"
                            cy={210}
                            r={206}
                            stroke="url(#speedometer2_svg__d)"
                            strokeWidth={6}
                          ></circle>
                          <circle
                            cx="210.471"
                            cy={210}
                            r={140}
                            stroke="url(#speedometer2_svg__e)"
                            strokeWidth={12}
                          ></circle>
                          <path
                            d="M22.357 200.603h2.4v14h-2.76v-11.08l-2.64.74-.68-2.36 3.68-1.3Zm10.514 5.38c-.64.627-1.44.94-2.4.94s-1.766-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.654-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.226.24-.34.54-.34.9s.114.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.654-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.226.24-.34.54-.34.9s.114.667.34.92ZM379.754 200.603h2.4v14h-2.76v-11.08l-2.64.74-.68-2.36 3.68-1.3Zm7.734 0h2.4v14h-2.76v-11.08l-2.64.74-.68-2.36 3.68-1.3Zm10.514 5.38c-.64.627-1.44.94-2.4.94s-1.766-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.654-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.226.24-.34.54-.34.9s.114.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.654-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.126 1.126 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.226.24-.34.54-.34.9s.114.667.34.92ZM26.9 157v-2.06l4.78-4.92c1.066-1.12 1.6-2.053 1.6-2.8 0-.547-.174-.987-.52-1.32-.334-.333-.767-.5-1.3-.5-1.054 0-1.834.547-2.34 1.64l-2.32-1.36c.44-.96 1.073-1.693 1.9-2.2a5.103 5.103 0 0 1 2.72-.76c1.266 0 2.353.4 3.26 1.2.906.787 1.36 1.853 1.36 3.2 0 1.453-.767 2.947-2.3 4.48L31 154.34h5.26V157H26.9Zm16.57-8.62c-.64.627-1.44.94-2.4.94s-1.768-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.652-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.228.24-.34.54-.34.9s.112.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.652-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.228.24-.34.54-.34.9s.112.667.34.92ZM379.647 147.58c0 1.08-.28 2.027-.84 2.84h.02l-4.36 6.58h-3.16l3.12-4.56c-1.453-.027-2.64-.487-3.56-1.38-.907-.907-1.36-2.067-1.36-3.48 0-1.427.467-2.593 1.4-3.5.947-.907 2.167-1.36 3.66-1.36 1.507 0 2.727.453 3.66 1.36.947.893 1.42 2.06 1.42 3.5Zm-7.4 0c0 .693.22 1.247.66 1.66.453.413 1.007.62 1.66.62.68 0 1.24-.207 1.68-.62.44-.413.66-.967.66-1.66s-.22-1.24-.66-1.64c-.44-.413-1-.62-1.68-.62-.653 0-1.207.207-1.66.62-.44.413-.66.96-.66 1.64Zm14.535.8c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.128 1.128 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM63.738 93.68c.946.28 1.713.773 2.3 1.48.6.693.9 1.533.9 2.52 0 1.44-.487 2.567-1.46 3.38-.96.813-2.14 1.22-3.54 1.22-1.094 0-2.074-.247-2.94-.74-.854-.507-1.474-1.247-1.86-2.22l2.36-1.36c.346 1.08 1.16 1.62 2.44 1.62.706 0 1.253-.167 1.64-.5.4-.347.6-.813.6-1.4 0-.573-.2-1.033-.6-1.38-.387-.347-.934-.52-1.64-.52h-.6l-1.06-1.6 2.76-3.6h-5.48V88h8.8v2.28l-2.62 3.4Zm9.913-.3c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.126 1.126 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM349.215 94.72c1.293.773 1.94 1.9 1.94 3.38 0 1.293-.453 2.313-1.36 3.06-.893.747-2.113 1.12-3.66 1.12-1.56 0-2.787-.373-3.68-1.12-.893-.747-1.34-1.767-1.34-3.06 0-1.48.64-2.607 1.92-3.38-.973-.707-1.46-1.673-1.46-2.9 0-1.293.433-2.3 1.3-3.02.88-.72 1.967-1.08 3.26-1.08 1.293 0 2.373.36 3.24 1.08.867.72 1.3 1.727 1.3 3.02 0 1.24-.487 2.207-1.46 2.9Zm-1.78-3.96c-.333-.293-.767-.44-1.3-.44s-.967.147-1.3.44c-.333.293-.5.693-.5 1.2s.167.913.5 1.22c.333.293.767.44 1.3.44s.967-.147 1.3-.44c.333-.307.5-.713.5-1.22s-.167-.907-.5-1.2Zm-2.96 8.42c.427.333.98.5 1.66.5.68 0 1.227-.167 1.64-.5.427-.347.64-.827.64-1.44 0-.6-.213-1.067-.64-1.4-.413-.347-.96-.52-1.64-.52-.68 0-1.233.173-1.66.52-.413.333-.62.8-.62 1.4 0 .613.207 1.093.62 1.44Zm13.637-5.8c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM117.841 55.06v2.56h-1.5V60h-2.78v-2.38h-6.62v-2.56l4.66-9.06h2.96l-4.64 9.06h3.64v-3.32h2.78v3.32h1.5Zm5.966-3.68c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM289.182 46h9.04v2.34L293.482 60h-2.92l4.6-11.36h-5.98V46Zm16.225 5.38c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92ZM171.141 30.1c1.347 0 2.48.407 3.4 1.22.92.8 1.38 1.92 1.38 3.36s-.487 2.567-1.46 3.38c-.96.813-2.14 1.22-3.54 1.22-1.133 0-2.133-.253-3-.76s-1.493-1.253-1.88-2.24l2.36-1.38c.347 1.12 1.187 1.68 2.52 1.68.707 0 1.253-.167 1.64-.5.4-.347.6-.813.6-1.4 0-.573-.193-1.033-.58-1.38-.387-.347-.913-.52-1.58-.52h-4.24l.56-7.78h7.94v2.58h-5.38l-.18 2.52h1.44Zm11.646.28c-.64.627-1.44.94-2.4.94s-1.766-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.654-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.226.24-.34.54-.34.9s.114.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.654-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.125 1.125 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.226.24-.34.54-.34.9s.114.667.34.92ZM234.3 29.54c1.453.04 2.633.513 3.54 1.42.906.893 1.36 2.04 1.36 3.44 0 1.427-.474 2.6-1.42 3.52-.947.907-2.167 1.36-3.66 1.36-1.494 0-2.714-.453-3.66-1.36-.934-.907-1.4-2.08-1.4-3.52 0-1.067.273-2.007.82-2.82l4.36-6.58h3.16l-3.1 4.54Zm-1.84 6.52c.44.413.993.62 1.66.62.666 0 1.22-.207 1.66-.62.453-.413.68-.967.68-1.66 0-.68-.227-1.227-.68-1.64-.44-.413-.994-.62-1.66-.62-.667 0-1.22.207-1.66.62-.44.4-.66.947-.66 1.64s.22 1.247.66 1.66Zm13.269-5.68c-.64.627-1.44.94-2.4.94s-1.767-.32-2.42-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.653-.64 1.46-.96 2.42-.96s1.76.32 2.4.96c.64.627.96 1.407.96 2.34 0 .933-.32 1.72-.96 2.36Zm-4.36 6.5 9.12-10.14 1.22.68-9.14 10.16-1.2-.7Zm1.04-7.94c.24.24.54.36.9.36s.66-.12.9-.36c.24-.253.36-.56.36-.92s-.12-.66-.36-.9-.54-.36-.9-.36-.66.12-.9.36c-.227.24-.34.54-.34.9s.113.667.34.92Zm10.08 9.34c-.64.64-1.44.96-2.4.96s-1.76-.32-2.4-.96c-.64-.64-.96-1.42-.96-2.34 0-.92.32-1.7.96-2.34.64-.64 1.44-.96 2.4-.96s1.76.32 2.4.96c.64.64.96 1.42.96 2.34 0 .92-.32 1.7-.96 2.34Zm-3.3-1.42c.24.24.54.36.9.36s.653-.127.88-.38c.24-.253.36-.553.36-.9 0-.36-.12-.66-.36-.9a1.127 1.127 0 0 0-.88-.38c-.36 0-.66.127-.9.38-.227.24-.34.54-.34.9s.113.667.34.92Z"
                            fill="#fff"
                          />
                          <g
                            opacity="0.2"
                            clipPath="url(#speedometer2_svg__f)"
                            stroke="#fff"
                            strokeMiterlimit={10}
                          >
                            <path d="M50.47 209.628h8.93M60.48 153.743l8.373 3.121M88.103 106.447l6.825 5.765M129.711 71.35l4.517 7.717M181.715 52.067l1.592 8.797M239.225 52.067l-1.592 8.797M291.23 71.35l-4.517 7.717M332.838 106.447l-6.824 5.765M360.462 153.743l-8.372 3.121M370.471 209.628h-8.93"></path>
                          </g>
                          <circle cx="210.471" cy={208} r={27} fill="#fff" />
                        </g>
                        <defs>
                          <linearGradient
                            id="speedometer2_svg__b"
                            x1="210.471"
                            y1={-124}
                            x2="210.471"
                            y2={210}
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#08204F" />
                            <stop
                              offset={1}
                              stopColor="#08204F"
                              stopOpacity={0}
                            />
                          </linearGradient>
                          <linearGradient
                            id="speedometer2_svg__c"
                            x1="210.471"
                            y1="-103.225"
                            x2="210.471"
                            y2={210}
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#3071EE" />
                            <stop
                              offset={1}
                              stopColor="#3071EE"
                              stopOpacity={0}
                            />
                          </linearGradient>
                          <linearGradient
                            id="speedometer2_svg__d"
                            x1="210.471"
                            y1={1}
                            x2="210.471"
                            y2={210}
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#C4D8FF" />
                            <stop
                              offset={1}
                              stopColor="#C4D8FF"
                              stopOpacity={0}
                            />
                          </linearGradient>
                          <linearGradient
                            id="speedometer2_svg__e"
                            x1="210.471"
                            y1={64}
                            x2="210.471"
                            y2={210}
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#C4D8FF" />
                            <stop
                              offset={1}
                              stopColor="#C4D8FF"
                              stopOpacity={0}
                            />
                          </linearGradient>
                          <clipPath id="speedometer2_svg__a">
                            <path
                              fill="#fff"
                              transform="translate(.47)"
                              d="M0 0h420v236H0z"
                            />
                          </clipPath>
                          <clipPath id="speedometer2_svg__f">
                            <path
                              fill="#fff"
                              transform="translate(50.47 52)"
                              d="M0 0h320v158H0z"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div className="Oval-sc-1dczjpv-0 Speedometer__OvalWrapper-sc-1frto4m-1 bqJIBA jfSUJt" />
                      <div className="Speedometer__ArrowWrapper-sc-1frto4m-2 dmEiAB" />
                    </div>
                    <p className="Speedometers__Text-sc-5off5-5 iRIcBm">
                      APY: <span>3%</span>
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 hXWeeJ">
              <div className="Container-sc-rx245t-0 dGblwP">
                <h2 className="Heading-sc-vfylp7-0 ImagesTexts__HeadingWrapper-sc-ywwyyr-0 jJrhee lgnAyG">
                  Staking pools with 5% APY are limited!
                </h2>
                <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 hXWeeJ ImagesTexts__ImageTextWrapper2-sc-ywwyyr-1 jPTBbq">
                  <div className="Container-sc-rx245t-0 ImageText__ContainerWrapper-sc-b2nury-0 dGblwP bSDLUs container">
                    <svg
                      width={494}
                      height={565}
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 500 560"
                      className="ImagesTexts__LockedBoxesWrapper-sc-ywwyyr-3 blZOvE"
                    >
                      <path
                        d="M251.017 401 138 335.491V204.508l113.017 65.509V401Z"
                        fill="#0A2BA8"
                      />
                      <path
                        d="m242.194 385.709-95.405-55.303V219.799l95.405 55.304v110.606Z"
                        fill="#132E48"
                      />
                      <path
                        d="m242.194 385.709-95.405-55.303V219.799l95.405 55.304v110.606Z"
                        fill="#132E48"
                      />
                      <path
                        d="m242.194 385.709-95.405-55.303V219.799l95.405 55.304v110.606ZM364.001 335.491 251.018 401V270.017l112.983-65.509v130.983Z"
                        fill="#08204F"
                      />
                      <path
                        d="m355.579 330.641-96.177 55.741V274.867l96.177-55.742v111.516Z"
                        fill="#08204F"
                      />
                      <path
                        d="M251.017 270.017 138 204.508 251.017 139 364 204.508l-112.983 65.509Z"
                        fill="#285DDA"
                      ></path>
                      <path
                        d="m251.017 261.024-97.552-56.516 97.552-56.549 97.518 56.549-97.518 56.516Z"
                        fill="#fff"
                      ></path>
                      <path
                        d="M251.017 262 138 196.491V65.508l113.017 65.509V262Z"
                        fill="#0A2BA8"
                      />
                      <path
                        d="m242.194 246.709-95.405-55.303V80.799l95.405 55.304v110.606Z"
                        fill="#132E48"
                      />
                      <path
                        d="m242.194 246.709-95.405-55.303V80.799l95.405 55.304v110.606Z"
                        fill="#132E48"
                      />
                      <path
                        d="m242.194 246.709-95.405-55.303V80.799l95.405 55.304v110.606Z"
                        fill="#08204F"
                      />
                      <path
                        d="M364.001 196.491 251.018 262V131.017l112.983-65.509v130.983Z"
                        fill="#0A3FBC"
                      />
                      <path
                        d="m355.579 191.641-96.177 55.741V135.867l96.177-55.741V191.64Z"
                        fill="#08204F"
                      />
                      <path
                        d="M251.017 131.017 138 65.508 251.017 0 364 65.508l-112.983 65.509Z"
                        fill="#285DDA"
                      />
                      <path
                        d="m251.017 122.024-97.552-56.516L251.017 8.96l97.518 56.55-97.518 56.515Z"
                        fill="url(#locked-boxes_svg__a)"
                      />
                      <path
                        d="M381.017 484 268 418.491V287.508l113.017 65.509V484Z"
                        fill="#0A2BA8"
                      />
                      <path
                        d="m372.194 468.709-95.405-55.303V302.799l95.405 55.304v110.606Z"
                        fill="#132E48"
                      />
                      <path
                        d="m372.194 468.709-95.405-55.303V302.799l95.405 55.304v110.606Z"
                        fill="#132E48"
                      />
                      <path
                        d="m372.194 468.709-95.405-55.303V302.799l95.405 55.304v110.606Z"
                        fill="#08204F"
                      />
                      <path
                        d="M494.001 418.491 381.018 484V353.017l112.983-65.509v130.983Z"
                        fill="#0A3FBC"
                      />
                      <path
                        d="m485.579 413.641-96.177 55.741V357.867l96.177-55.742v111.516Z"
                        fill="#08204F"
                      />
                      <path
                        d="M381.017 353.017 268 287.508 381.017 222 494 287.508l-112.983 65.509Z"
                        fill="#285DDA"
                      ></path>
                      <path
                        d="m381.017 344.024-97.552-56.516 97.552-56.549 97.518 56.549-97.518 56.516Z"
                        fill="#fff"
                      ></path>
                      <g clipPath="url(#locked-boxes_svg__b)">
                        <path
                          d="M381.017 344 268 278.742V148.258l113.017 65.259V344Z"
                          fill="#0A2BA8"
                        />
                        <path
                          d="m372.194 328.767-95.405-55.092V163.491l95.405 55.092v110.184Z"
                          fill="#132E48"
                        />
                        <path
                          d="m372.194 328.767-95.405-55.092V163.491l95.405 55.092v110.184Z"
                          fill="#132E48"
                        />
                        <path
                          d="m372.194 328.767-95.405-55.092V163.491l95.405 55.092v110.184Z"
                          fill="#08204F"
                        />
                        <path
                          d="m372.194 328.767-95.405-55.092V163.491l95.405 55.092v110.184Z"
                          fill="url(#locked-boxes_svg__c)"
                        />
                        <path
                          d="M494.001 278.742 381.018 344V213.517l112.983-65.259v130.484Z"
                          fill="#0A3FBC"
                        />
                        <path
                          d="m485.579 273.91-96.177 55.528v-111.09l96.177-55.528v111.09Z"
                          fill="url(#locked-boxes_svg__d)"
                        />
                        <path
                          d="M381.017 213.517 268 148.258 381.017 83 494 148.258l-112.983 65.259Z"
                          fill="#285DDA"
                        ></path>
                        <path
                          d="m381.017 204.558-97.552-56.3 97.552-56.333 97.518 56.333-97.518 56.3Z"
                          fill="url(#locked-boxes_svg__e)"
                        />
                      </g>
                      <path
                        d="M113.017 483 0 417.491V286.508l113.017 65.509V483Z"
                        fill="#0A2BA8"
                      />
                      <path
                        d="M104.194 467.709 8.789 412.406V301.799l95.405 55.304v110.606Z"
                        fill="#132E48"
                      />
                      <path
                        d="M104.194 467.709 8.789 412.406V301.799l95.405 55.304v110.606Z"
                        fill="#132E48"
                      />
                      <path
                        d="M104.194 467.709 8.789 412.406V301.799l95.405 55.304v110.606Z"
                        fill="#08204F"
                      />
                      <path
                        d="M226.001 417.491 113.018 483V352.017l112.983-65.509v130.983Z"
                        fill="#0A3FBC"
                      />
                      <path
                        d="m217.579 412.641-96.177 55.741V356.867l96.177-55.742v111.516Z"
                        fill="#08204F"
                      />
                      <path
                        d="M113.017 352.017 0 286.508 113.017 221 226 286.508l-112.983 65.509Z"
                        fill="#285DDA"
                      />
                      <path
                        d="m113.017 343.024-97.552-56.516 97.552-56.549 97.518 56.549-97.518 56.516Z"
                        fill="#fff"
                      ></path>
                      <g clipPath="url(#locked-boxes_svg__f)">
                        <path
                          d="M113.017 343 0 277.742V147.258l113.017 65.259V343Z"
                          fill="#0A2BA8"
                        />
                        <path
                          d="M104.194 327.767 8.789 272.675V162.491l95.405 55.092v110.184Z"
                          fill="#132E48"
                        />
                        <path
                          d="M104.194 327.767 8.789 272.675V162.491l95.405 55.092v110.184Z"
                          fill="#132E48"
                        />
                        <path
                          d="M104.194 327.767 8.789 272.675V162.491l95.405 55.092v110.184Z"
                          fill="#08204F"
                        />
                        <path
                          d="M226.001 277.742 113.018 343V212.517l112.983-65.259v130.484Z"
                          fill="#0A3FBC"
                        />
                        <path
                          d="m217.579 272.91-96.177 55.528v-111.09l96.177-55.528v111.09Z"
                          fill="#08204F"
                        />
                        <path
                          d="m217.579 272.91-96.177 55.528v-111.09l96.177-55.528v111.09Z"
                          fill="url(#locked-boxes_svg__g)"
                        />
                        <path
                          d="M113.017 212.517 0 147.258 113.017 82 226 147.258l-112.983 65.259Z"
                          fill="#285DDA"
                        ></path>
                        <path
                          d="m113.017 203.558-97.552-56.3 97.552-56.333 97.518 56.333-97.518 56.3Z"
                          fill="url(#locked-boxes_svg__h)"
                        />
                      </g>
                      <g clipPath="url(#locked-boxes_svg__i)">
                        <path
                          d="M252.017 565 139 499.742V369.258l113.017 65.259V565Z"
                          fill="#0A2BA8"
                        />
                        <path
                          d="m243.194 549.767-95.405-55.092V384.491l95.405 55.092v110.184Z"
                          fill="#132E48"
                        />
                        <path
                          d="m243.194 549.767-95.405-55.092V384.491l95.405 55.092v110.184Z"
                          fill="#132E48"
                        />
                        <path
                          d="m243.194 549.767-95.405-55.092V384.491l95.405 55.092v110.184Z"
                          fill="#08204F"
                        />
                        <path
                          d="M365.001 499.742 252.018 565V434.517l112.983-65.259v130.484Z"
                          fill="#0A3FBC"
                        />
                        <path
                          d="m356.579 494.91-96.177 55.528v-111.09l96.177-55.528v111.09Z"
                          fill="#08204F"
                        />
                        <path
                          d="M252.017 434.517 139 369.258 252.017 304 365 369.258l-112.983 65.259Z"
                          fill="#285DDA"
                        ></path>
                        <path
                          d="m252.017 425.558-97.552-56.3 97.552-56.333 97.518 56.333-97.518 56.3Z"
                          fill="#08204F"
                        ></path>
                        <path
                          d="m252.017 425.558-97.552-56.3 97.552-56.333 97.518 56.333-97.518 56.3Z"
                          fill="url(#locked-boxes_svg__j)"
                        />
                      </g>
                      <g filter="url(#locked-boxes_svg__k)">
                        <circle
                          cx={251}
                          cy={270}
                          r={74}
                          fill="#51DDB9"
                          fillOpacity="0.1"
                        />
                        <circle
                          cx={251}
                          cy={270}
                          r={73}
                          stroke="#51DDB9"
                          strokeWidth={2}
                        />
                      </g>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M225 271.571c0-7.757 6.289-14.046 14.046-14.046h23.658c7.757 0 14.046 6.289 14.046 14.046V283.4c0 7.758-6.289 14.046-14.046 14.046h-23.658c-7.757 0-14.046-6.288-14.046-14.046v-11.829Zm27.875 2.958a2 2 0 1 0-4 0v5.914a2 2 0 0 0 4 0v-5.914Z"
                        fill="#51DDB9"
                      />
                      <path
                        d="M262.704 259.743v-5.914c0-6.533-5.296-11.829-11.829-11.829-6.532 0-11.828 5.296-11.828 11.829v5.914"
                        stroke="#51DDB9"
                        strokeWidth={4}
                      />
                      <defs>
                        <linearGradient
                          id="locked-boxes_svg__a"
                          x1={251}
                          y1="8.959"
                          x2={251}
                          y2="211.808"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#08204F" />
                          <stop offset={1} stopColor="#285DDA" />
                        </linearGradient>
                        <linearGradient
                          id="locked-boxes_svg__c"
                          x1="285.621"
                          y1={285}
                          x2="368.5"
                          y2="202.121"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#285DDA" />
                          <stop offset={1} stopOpacity={0} />
                        </linearGradient>
                        <linearGradient
                          id="locked-boxes_svg__d"
                          x1="437.491"
                          y1="162.82"
                          x2="437.491"
                          y2="329.438"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#08204F" />
                          <stop offset={1} stopColor="#08204F" />
                        </linearGradient>
                        <linearGradient
                          id="locked-boxes_svg__e"
                          x1={381}
                          y1="91.925"
                          x2={381}
                          y2={294}
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#08204F" />
                          <stop offset={1} stopColor="#285DDA" />
                        </linearGradient>
                        <linearGradient
                          id="locked-boxes_svg__g"
                          x1="194.496"
                          y1="293.5"
                          x2="120.998"
                          y2="219.998"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#285DDA" />
                          <stop offset={1} stopOpacity={0} />
                        </linearGradient>
                        <linearGradient
                          id="locked-boxes_svg__h"
                          x1={113}
                          y1="90.925"
                          x2={113}
                          y2={293}
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#08204F" />
                          <stop offset={1} stopColor="#285DDA" />
                        </linearGradient>
                        <linearGradient
                          id="locked-boxes_svg__j"
                          x1="252.004"
                          y1={313}
                          x2="252.004"
                          y2={447}
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#285DDA" />
                          <stop offset={1} stopOpacity={0} />
                        </linearGradient>
                        <clipPath id="locked-boxes_svg__b">
                          <path
                            fill="#fff"
                            transform="translate(268 83)"
                            d="M0 0h226v261H0z"
                          />
                        </clipPath>
                        <clipPath id="locked-boxes_svg__f">
                          <path
                            fill="#fff"
                            transform="translate(0 82)"
                            d="M0 0h226v261H0z"
                          />
                        </clipPath>
                        <clipPath id="locked-boxes_svg__i">
                          <path
                            fill="#fff"
                            transform="translate(139 304)"
                            d="M0 0h226v261H0z"
                          />
                        </clipPath>
                        <filter
                          id="locked-boxes_svg__k"
                          x={137}
                          y={156}
                          width={228}
                          height={228}
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity={0}
                            result="BackgroundImageFix"
                          />
                          <feGaussianBlur
                            in="BackgroundImage"
                            stdDeviation={20}
                          />
                          <feComposite
                            in2="SourceAlpha"
                            operator="in"
                            result="effect1_backgroundBlur_739_8697"
                          ></feComposite>
                          <feBlend
                            in="SourceGraphic"
                            in2="effect1_backgroundBlur_739_8697"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div className="ImageText__TitleText-sc-b2nury-1 kvvBpD titleText">
                      <p className="Paragraph-sc-1i3reiv-0 dWGaaX text">
                        {siteSettings.siteName} must impose a strict limit on
                        available 5% APY staking pools to provide the best
                        possible returns in the market. To ensure your chance to
                        start earning fixed returns with an honest percentage,
                        follow our email newsletters and push notifications.
                      </p>
                      <a
                        href={siteSettings.appLink}
                        className="ButtonLink-sc-125kju0-0 ImagesTexts__ButtonWrapper-sc-ywwyyr-2 jppsNF iqitOO"
                      >
                        Get Started
                      </a>
                    </div>
                  </div>
                </section>
              </div>
            </section>
            {/* <section className="Wrapper__SectionWrapper-sc-1wxi09o-0 hXWeeJ">
              <div className="Container-sc-rx245t-0 dGblwP">
                <h2 className="Heading-sc-vfylp7-0 FaqBlock__HeadingWrapper-sc-73ena4-0 jJrhee gbXFhu">
                  Frequently Asked Questions
                </h2>
                <ul className="Ul-sc-1f2qrkb-0 FaqBlockFaqList__FAQList-sc-119o49x-0 dmohgA kNBxeY">
                  <li className="FaqBlockFaqList__FAQItem-sc-119o49x-1 dyMBYZ">
                    <div className="FaqBlockFaqList__TextContainer-sc-119o49x-2 dGWBVr">
                      <div className="FaqBlockFaqList__TitleContainer-sc-119o49x-3 bNVpsU">
                        <div className="FaqBlockFaqList__Title-sc-119o49x-4 bFRWTq">
                          What do I need to start staking?
                        </div>
                        <div className="FaqBlockFaqList__IconContainer-sc-119o49x-5 hWUyJD">
                          <svg
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g filter="url(#filter0_b_821_8970)">
                              <circle
                                r={24}
                                transform="matrix(1 0 0 -1 24 24)"
                                fill="#3071EE"
                                fillOpacity="0.1"
                              ></circle>
                              <circle
                                r={23}
                                transform="matrix(1 0 0 -1 24 24)"
                                stroke="#3071EE"
                                strokeWidth={2}
                              ></circle>
                            </g>
                            <path
                              d="M25.5 34C25.5 34.8284 24.8284 35.5 24 35.5C23.1716 35.5 22.5 34.8284 22.5 34H25.5ZM22.9393 12.9393C23.5251 12.3536 24.4749 12.3536 25.0607 12.9393L34.6066 22.4853C35.1924 23.0711 35.1924 24.0208 34.6066 24.6066C34.0208 25.1924 33.0711 25.1924 32.4853 24.6066L24 16.1213L15.5147 24.6066C14.9289 25.1924 13.9792 25.1924 13.3934 24.6066C12.8076 24.0208 12.8076 23.0711 13.3934 22.4853L22.9393 12.9393ZM22.5 34V14H25.5V34H22.5Z"
                              fill="#3071EE"
                            />
                            <defs>
                              <filter
                                id="filter0_b_821_8970"
                                x={-40}
                                y={-40}
                                width={128}
                                height={128}
                                filterUnits="userSpaceOnUse"
                                colorInterpolationFilters="sRGB"
                              >
                                <feFlood
                                  floodOpacity={0}
                                  result="BackgroundImageFix"
                                />
                                <feGaussianBlur
                                  in="BackgroundImage"
                                  stdDeviation={20}
                                />
                                <feComposite
                                  in2="SourceAlpha"
                                  operator="in"
                                  result="effect1_backgroundBlur_821_8970"
                                ></feComposite>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_backgroundBlur_821_8970"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div
                        height={0}
                        className="FaqBlockFaqList__DescriptionContainer-sc-119o49x-6 kxobxK"
                      >
                        <div className="FaqBlockFaqList__Description-sc-119o49x-7 iWrfuX">
                          Simply deposit any coin that is available for staking
                          and enable staking on the Wallet page of your account.
                          It's that simple! There are no limits for
                          withdrawing/trading your staked balance. For
                          additional convenience, we have prepared a short and
                          simple tutorial -{" "}
                          <a
                            href="https://help.{siteSettings.siteName}.com/help-center/staking/stake-unstake"
                            style={{ color: "#51DDB9" }}
                          >
                            How to start Staking.
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="FaqBlockFaqList__FAQItem-sc-119o49x-1 dyMBYZ">
                    <div className="FaqBlockFaqList__TextContainer-sc-119o49x-2 dGWBVr">
                      <div className="FaqBlockFaqList__TitleContainer-sc-119o49x-3 bNVpsU">
                        <div className="FaqBlockFaqList__Title-sc-119o49x-4 bFRWTq">
                          Can I continue trading if I stake my coins? How is it
                          possible to trade the staked coins?
                        </div>
                        <div className="FaqBlockFaqList__IconContainer-sc-119o49x-5 hWUyJD">
                          <svg
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g filter="url(#filter0_b_821_8970)">
                              <circle
                                r={24}
                                transform="matrix(1 0 0 -1 24 24)"
                                fill="#3071EE"
                                fillOpacity="0.1"
                              ></circle>
                              <circle
                                r={23}
                                transform="matrix(1 0 0 -1 24 24)"
                                stroke="#3071EE"
                                strokeWidth={2}
                              ></circle>
                            </g>
                            <path
                              d="M25.5 34C25.5 34.8284 24.8284 35.5 24 35.5C23.1716 35.5 22.5 34.8284 22.5 34H25.5ZM22.9393 12.9393C23.5251 12.3536 24.4749 12.3536 25.0607 12.9393L34.6066 22.4853C35.1924 23.0711 35.1924 24.0208 34.6066 24.6066C34.0208 25.1924 33.0711 25.1924 32.4853 24.6066L24 16.1213L15.5147 24.6066C14.9289 25.1924 13.9792 25.1924 13.3934 24.6066C12.8076 24.0208 12.8076 23.0711 13.3934 22.4853L22.9393 12.9393ZM22.5 34V14H25.5V34H22.5Z"
                              fill="#3071EE"
                            />
                            <defs>
                              <filter
                                id="filter0_b_821_8970"
                                x={-40}
                                y={-40}
                                width={128}
                                height={128}
                                filterUnits="userSpaceOnUse"
                                colorInterpolationFilters="sRGB"
                              >
                                <feFlood
                                  floodOpacity={0}
                                  result="BackgroundImageFix"
                                />
                                <feGaussianBlur
                                  in="BackgroundImage"
                                  stdDeviation={20}
                                />
                                <feComposite
                                  in2="SourceAlpha"
                                  operator="in"
                                  result="effect1_backgroundBlur_821_8970"
                                ></feComposite>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_backgroundBlur_821_8970"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div
                        height={0}
                        className="FaqBlockFaqList__DescriptionContainer-sc-119o49x-6 kxobxK"
                      >
                        <div className="FaqBlockFaqList__Description-sc-119o49x-7 iWrfuX">
                          Yes, your staked funds are not locked and are
                          available for trading. This is possible because staked
                          coins are used as a collateral and, with the help of
                          our liquidity partners, provide customers with
                          zero-interest loans that they can use for trading.
                          This is an automated process that happens on the back
                          end and is completely seamless for end users, just
                          like regular trading.
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="FaqBlockFaqList__FAQItem-sc-119o49x-1 dyMBYZ">
                    <div className="FaqBlockFaqList__TextContainer-sc-119o49x-2 dGWBVr">
                      <div className="FaqBlockFaqList__TitleContainer-sc-119o49x-3 bNVpsU">
                        <div className="FaqBlockFaqList__Title-sc-119o49x-4 bFRWTq">
                          How often do I receive yield from staking coins?
                        </div>
                        <div className="FaqBlockFaqList__IconContainer-sc-119o49x-5 hWUyJD">
                          <svg
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g filter="url(#filter0_b_821_8970)">
                              <circle
                                r={24}
                                transform="matrix(1 0 0 -1 24 24)"
                                fill="#3071EE"
                                fillOpacity="0.1"
                              ></circle>
                              <circle
                                r={23}
                                transform="matrix(1 0 0 -1 24 24)"
                                stroke="#3071EE"
                                strokeWidth={2}
                              ></circle>
                            </g>
                            <path
                              d="M25.5 34C25.5 34.8284 24.8284 35.5 24 35.5C23.1716 35.5 22.5 34.8284 22.5 34H25.5ZM22.9393 12.9393C23.5251 12.3536 24.4749 12.3536 25.0607 12.9393L34.6066 22.4853C35.1924 23.0711 35.1924 24.0208 34.6066 24.6066C34.0208 25.1924 33.0711 25.1924 32.4853 24.6066L24 16.1213L15.5147 24.6066C14.9289 25.1924 13.9792 25.1924 13.3934 24.6066C12.8076 24.0208 12.8076 23.0711 13.3934 22.4853L22.9393 12.9393ZM22.5 34V14H25.5V34H22.5Z"
                              fill="#3071EE"
                            />
                            <defs>
                              <filter
                                id="filter0_b_821_8970"
                                x={-40}
                                y={-40}
                                width={128}
                                height={128}
                                filterUnits="userSpaceOnUse"
                                colorInterpolationFilters="sRGB"
                              >
                                <feFlood
                                  floodOpacity={0}
                                  result="BackgroundImageFix"
                                />
                                <feGaussianBlur
                                  in="BackgroundImage"
                                  stdDeviation={20}
                                />
                                <feComposite
                                  in2="SourceAlpha"
                                  operator="in"
                                  result="effect1_backgroundBlur_821_8970"
                                ></feComposite>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_backgroundBlur_821_8970"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div
                        height={0}
                        className="FaqBlockFaqList__DescriptionContainer-sc-119o49x-6 kxobxK"
                      >
                        <div className="FaqBlockFaqList__Description-sc-119o49x-7 iWrfuX">
                          Any yield received from staking is credited daily to
                          the wallet balance for the corresponding coin.
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="FaqBlockFaqList__FAQItem-sc-119o49x-1 dyMBYZ">
                    <div className="FaqBlockFaqList__TextContainer-sc-119o49x-2 dGWBVr">
                      <div className="FaqBlockFaqList__TitleContainer-sc-119o49x-3 bNVpsU">
                        <div className="FaqBlockFaqList__Title-sc-119o49x-4 bFRWTq">
                          When can I stake/un-stake my funds? Will this affect
                          my earnings
                        </div>
                        <div className="FaqBlockFaqList__IconContainer-sc-119o49x-5 hWUyJD">
                          <svg
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g filter="url(#filter0_b_821_8970)">
                              <circle
                                r={24}
                                transform="matrix(1 0 0 -1 24 24)"
                                fill="#3071EE"
                                fillOpacity="0.1"
                              ></circle>
                              <circle
                                r={23}
                                transform="matrix(1 0 0 -1 24 24)"
                                stroke="#3071EE"
                                strokeWidth={2}
                              ></circle>
                            </g>
                            <path
                              d="M25.5 34C25.5 34.8284 24.8284 35.5 24 35.5C23.1716 35.5 22.5 34.8284 22.5 34H25.5ZM22.9393 12.9393C23.5251 12.3536 24.4749 12.3536 25.0607 12.9393L34.6066 22.4853C35.1924 23.0711 35.1924 24.0208 34.6066 24.6066C34.0208 25.1924 33.0711 25.1924 32.4853 24.6066L24 16.1213L15.5147 24.6066C14.9289 25.1924 13.9792 25.1924 13.3934 24.6066C12.8076 24.0208 12.8076 23.0711 13.3934 22.4853L22.9393 12.9393ZM22.5 34V14H25.5V34H22.5Z"
                              fill="#3071EE"
                            />
                            <defs>
                              <filter
                                id="filter0_b_821_8970"
                                x={-40}
                                y={-40}
                                width={128}
                                height={128}
                                filterUnits="userSpaceOnUse"
                                colorInterpolationFilters="sRGB"
                              >
                                <feFlood
                                  floodOpacity={0}
                                  result="BackgroundImageFix"
                                />
                                <feGaussianBlur
                                  in="BackgroundImage"
                                  stdDeviation={20}
                                />
                                <feComposite
                                  in2="SourceAlpha"
                                  operator="in"
                                  result="effect1_backgroundBlur_821_8970"
                                ></feComposite>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_backgroundBlur_821_8970"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div
                        height={0}
                        className="FaqBlockFaqList__DescriptionContainer-sc-119o49x-6 kxobxK"
                      >
                        <div className="FaqBlockFaqList__Description-sc-119o49x-7 iWrfuX">
                          Every pending request to stake or un-stake funds is
                          processed once a day. Earnings received will be
                          calculated based on the amount of funds staked since
                          the previous processing period
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="FaqBlockFaqList__FAQItem-sc-119o49x-1 dyMBYZ">
                    <div className="FaqBlockFaqList__TextContainer-sc-119o49x-2 dGWBVr">
                      <div className="FaqBlockFaqList__TitleContainer-sc-119o49x-3 bNVpsU">
                        <div className="FaqBlockFaqList__Title-sc-119o49x-4 bFRWTq">
                          Are there any limits to staking? How much coins can I
                          stake at a time
                        </div>
                        <div className="FaqBlockFaqList__IconContainer-sc-119o49x-5 hWUyJD">
                          <svg
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g filter="url(#filter0_b_821_8970)">
                              <circle
                                r={24}
                                transform="matrix(1 0 0 -1 24 24)"
                                fill="#3071EE"
                                fillOpacity="0.1"
                              ></circle>
                              <circle
                                r={23}
                                transform="matrix(1 0 0 -1 24 24)"
                                stroke="#3071EE"
                                strokeWidth={2}
                              ></circle>
                            </g>
                            <path
                              d="M25.5 34C25.5 34.8284 24.8284 35.5 24 35.5C23.1716 35.5 22.5 34.8284 22.5 34H25.5ZM22.9393 12.9393C23.5251 12.3536 24.4749 12.3536 25.0607 12.9393L34.6066 22.4853C35.1924 23.0711 35.1924 24.0208 34.6066 24.6066C34.0208 25.1924 33.0711 25.1924 32.4853 24.6066L24 16.1213L15.5147 24.6066C14.9289 25.1924 13.9792 25.1924 13.3934 24.6066C12.8076 24.0208 12.8076 23.0711 13.3934 22.4853L22.9393 12.9393ZM22.5 34V14H25.5V34H22.5Z"
                              fill="#3071EE"
                            />
                            <defs>
                              <filter
                                id="filter0_b_821_8970"
                                x={-40}
                                y={-40}
                                width={128}
                                height={128}
                                filterUnits="userSpaceOnUse"
                                colorInterpolationFilters="sRGB"
                              >
                                <feFlood
                                  floodOpacity={0}
                                  result="BackgroundImageFix"
                                />
                                <feGaussianBlur
                                  in="BackgroundImage"
                                  stdDeviation={20}
                                />
                                <feComposite
                                  in2="SourceAlpha"
                                  operator="in"
                                  result="effect1_backgroundBlur_821_8970"
                                ></feComposite>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_backgroundBlur_821_8970"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div
                        height={0}
                        className="FaqBlockFaqList__DescriptionContainer-sc-119o49x-6 kxobxK"
                      >
                        <div className="FaqBlockFaqList__Description-sc-119o49x-7 iWrfuX">
                          Currently there are no specific predefined limits to
                          the amount of coins that can be staked. However, it is
                          important to keep in mind that the pie-chart icon on
                          the Wallet page reflects the current amount of
                          liquidity available for new stakings for each separate
                          coin. A full pie-chart indicates that new coins can be
                          staked, while an empy pie-chart indicates that
                          currently staking is not available until additional
                          liquidity becomes available in the pool of various
                          DEFI and CEFI projects used in our staking program
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="FaqBlockFaqList__FAQItem-sc-119o49x-1 dyMBYZ">
                    <div className="FaqBlockFaqList__TextContainer-sc-119o49x-2 dGWBVr">
                      <div className="FaqBlockFaqList__TitleContainer-sc-119o49x-3 bNVpsU">
                        <div className="FaqBlockFaqList__Title-sc-119o49x-4 bFRWTq">
                          Is the APY% guaranteed to always be the same?
                        </div>
                        <div className="FaqBlockFaqList__IconContainer-sc-119o49x-5 hWUyJD">
                          <svg
                            viewBox="0 0 48 48"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g filter="url(#filter0_b_821_8970)">
                              <circle
                                r={24}
                                transform="matrix(1 0 0 -1 24 24)"
                                fill="#3071EE"
                                fillOpacity="0.1"
                              ></circle>
                              <circle
                                r={23}
                                transform="matrix(1 0 0 -1 24 24)"
                                stroke="#3071EE"
                                strokeWidth={2}
                              ></circle>
                            </g>
                            <path
                              d="M25.5 34C25.5 34.8284 24.8284 35.5 24 35.5C23.1716 35.5 22.5 34.8284 22.5 34H25.5ZM22.9393 12.9393C23.5251 12.3536 24.4749 12.3536 25.0607 12.9393L34.6066 22.4853C35.1924 23.0711 35.1924 24.0208 34.6066 24.6066C34.0208 25.1924 33.0711 25.1924 32.4853 24.6066L24 16.1213L15.5147 24.6066C14.9289 25.1924 13.9792 25.1924 13.3934 24.6066C12.8076 24.0208 12.8076 23.0711 13.3934 22.4853L22.9393 12.9393ZM22.5 34V14H25.5V34H22.5Z"
                              fill="#3071EE"
                            />
                            <defs>
                              <filter
                                id="filter0_b_821_8970"
                                x={-40}
                                y={-40}
                                width={128}
                                height={128}
                                filterUnits="userSpaceOnUse"
                                colorInterpolationFilters="sRGB"
                              >
                                <feFlood
                                  floodOpacity={0}
                                  result="BackgroundImageFix"
                                />
                                <feGaussianBlur
                                  in="BackgroundImage"
                                  stdDeviation={20}
                                />
                                <feComposite
                                  in2="SourceAlpha"
                                  operator="in"
                                  result="effect1_backgroundBlur_821_8970"
                                ></feComposite>
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_backgroundBlur_821_8970"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div
                        height={0}
                        className="FaqBlockFaqList__DescriptionContainer-sc-119o49x-6 kxobxK"
                      >
                        <div className="FaqBlockFaqList__Description-sc-119o49x-7 iWrfuX">
                          The reflected annual percentage yield (apy) % reflects
                          the average percentage taking into account all of the
                          DEFI and CEFI projects that are included in the
                          staking pool. The actual APY% received will depend on
                          numerous markets factors such as supply/demand,
                          liquidity, volatility, etc, and may be higher or
                          lower.
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </section> */}
          </div>

          {/* footer */}
          <Footer />
        </div>
      </div>
      <div
        id="gatsby-announcer"
        style={{
          position: "absolute",
          top: 0,
          width: 1,
          height: 1,
          padding: 0,
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
        aria-live="assertive"
        aria-atomic="true"
      />
      <div className="Toastify" />
      <div />
    </div>
  );
};

export default Staking;
